(function() {
  'use strict';

  // ═══ TRACKING INIT (gtag primaer, dataLayer nur Fallback) ═══
  window.dataLayer = window.dataLayer || [];

  // ═══ DATA ═══

  var DECISION_TREES = {
    Innenfarben: [
      { label: 'Raum', text: 'Welchen Raum möchtest du streichen?', options: [
        'Wohnzimmer', 'Schlafzimmer', 'Kinderzimmer', 'Küche', 'Bad/Dusche', 'Flur/Treppenhaus', 'Keller'
      ]},
      { label: 'Untergrund', text: 'Wie sieht die Wand aktuell aus?', options: [
        'Raufaser', 'Glattputz', 'Gipskarton', 'Beton', 'Altanstrich (überstrichen)', 'Tapete (andere)'
      ]},
      { label: 'Anforderung', text: 'Hast du besondere Anforderungen?', options: [
        'Keine besonderen', 'Abwaschbar/strapazierfähig', 'Allergikerfreundlich', 'Schimmelschutz', 'Hohe Deckkraft'
      ]}
    ],
    Fassaden: [
      { label: 'Untergrund', text: 'Welchen Untergrund hat deine Fassade?', options: [
        'Mineralischer Putz', 'Mauerwerk/Sichtbeton', 'WDVS (Wärmedämmung)', 'Vorgestrichen (Altanstrich)', 'Holzfassade'
      ]},
      { label: 'Zustand', text: 'In welchem Zustand ist die Fassade?', options: [
        'Gut (leichte Verschmutzung)', 'Mittel (Risse/Verfärbungen/Algen)', 'Schlecht (Abblätternd/starke Schäden)'
      ]},
      { label: 'Anforderung', text: 'Hast du besondere Anforderungen?', options: [
        'Keine besonderen', 'Selbstreinigend (Lotuseffekt)', 'Algen-/Schimmelresistent', 'Farbig (nicht Weiß)', 'Denkmalschutz/Silikat'
      ]}
    ],
    Holz: [
      { label: 'Einsatzort', text: 'Wo befindet sich das Bauteil?', options: [
        'Innen', 'Außen'
      ]},
      { label: 'Bauteil', text: 'Was möchtest du streichen?', options: [
        'Fenster/Türen', 'Möbel/Regale', 'Terrasse/Zaun', 'Carport/Gartenhaus', 'Geländer/Metall'
      ]},
      { label: 'Zustand', text: 'Wie ist der aktuelle Zustand?', options: [
        'Neu (unbehandelt)', 'Renovieren (alter Anstrich)', 'Auffrischen'
      ]},
      { label: 'Optik', text: 'Welche Optik wünschst du dir?', options: [
        'Deckend (Lack)', 'Lasierend (Holzmaserung sichtbar)', 'Öl/Wachs (natürlich)'
      ]}
    ],
    Malervlies: [
      { label: 'Untergrund', text: 'Wie sieht deine Wand aktuell aus?', options: [
        'Glattputz/Gipskarton', 'Raufaser (übertapezieren)', 'Risse im Putz', 'Altanstrich/alte Tapete', 'Neubau (Erstbezug)'
      ]},
      { label: 'Optik', text: 'Welche Oberfläche wünschst du dir?', options: [
        'Glatt (wie gespachtelt)', 'Leichte Struktur', 'Deutliche Struktur/Gewebe', 'Dekorative Musterung'
      ]},
      { label: 'Erfahrung', text: 'Wie erfahren bist du beim Tapezieren?', options: [
        'Anfänger/Heimwerker', 'Fortgeschritten', 'Profi/Maler'
      ]}
    ],
    Kreativtechnik: [
      { label: 'Einsatzort', text: 'Wo soll die Kreativtechnik zum Einsatz kommen?', options: [
        'Innen (Wohnraum)', 'Innen (Bad/Küche)', 'Außen (Fassade)'
      ]},
      { label: 'Effekt', text: 'Welchen Effekt wünschst du dir?', options: [
        'Wischtechnik/Lasur', 'Punktstruktur/Spritzoptik', 'Marmoroptik/Stucco', 'Wachs-/Seideneffekt', 'Reibeputz/Strukturputz'
      ]},
      { label: 'Untergrund', text: 'Wie sieht der Untergrund aus?', options: [
        'Glattputz (neu)', 'Bereits gestrichen', 'Gipskarton/Rigips', 'Mineralischer Putz'
      ]}
    ]
  };

  // Echte Produktzahl des Shops (Shopify products/count), per Section-Setting pflegbar.
  var KATALOG_GROESSE = (function() {
    var c = document.getElementById('projektberater-v4-app');
    var v = c && parseInt(c.getAttribute('data-katalog-groesse'), 10);
    return (v && v > 0) ? v : 460;
  })();

  var LOADING_STEPS = [
    'Dein Untergrund wird analysiert',
    'Passender Systemaufbau wird ermittelt',
    'Materialverbrauch wird berechnet',
    'Deine persönliche Empfehlung wird erstellt'
  ];

  var ZUBEHOER_MAP = {
    Innenfarben: ['storoller-finecoat', 'storoller-handle', 'storoller-paintgrid', 'sto-flachpinsel-profi', 'kip-3808-washi-tape', 'sto-abdeckfolie-hdpe'],
    Fassaden: ['storoller-roughcoat', 'storoller-handle', 'sto-fassadenstreicher-profi-schwarz', 'kip-3808-washi-tape', 'sto-abdeckvlies'],
    Holz: ['sto-flachpinsel-profi', 'storoller-handle', 'kip-3808-washi-tape', 'sto-abdeckfolie-hdpe'],
    Malervlies: ['sto-tapezierwischer-standard', 'sto-tapezierspachtel', 'sto-tapeten-andruckroller', 'storoller-paintgrid'],
    Kreativtechnik: ['storoller-effect', 'sto-glattekelle-profi', 'sto-flachpinsel-profi', 'sto-abdeckfolie-hdpe'],
    auto: ['storoller-finecoat', 'storoller-handle', 'storoller-paintgrid', 'sto-flachpinsel-profi', 'kip-3808-washi-tape', 'sto-abdeckfolie-hdpe']
  };

  var ZUBEHOER_BESCHREIBUNG = {
    'storoller-finecoat': 'Für gleichmäßigen Farbauftrag auf glatten Flächen',
    'storoller-roughcoat': 'Für strukturierte Fassadenoberflächen',
    'storoller-handle': 'Stabiler Bügel – passend zu deiner Walze',
    'sto-flachpinsel-profi': 'Für saubere Kanten, Ecken und Anschlüsse',
    'sto-fassadenstreicher-profi-schwarz': 'Für großflächigen Anstrich an der Fassade',
    'kip-3808-washi-tape': 'Saubere Kanten ohne Farbunterlauf',
    'storoller-paintgrid': 'Abstreifgitter für den Eimer – gleichmäßig dosieren statt tropfen',
    'sto-abdeckfolie-hdpe': 'Schützt Boden und Möbel vor Farbspritzern',
    'sto-abdeckvlies': 'Rutschfester Bodenschutz für außen',
    'sto-tapezierwischer-standard': 'Glättet Vlies blasenfrei an die Wand',
    'sto-tapezierspachtel': 'Für präzises Ansetzen und Zuschneiden',
    'sto-tapeten-andruckroller': 'Drückt Nähte unsichtbar fest',
    'storoller-paintgrid': 'Gleichmäßige Farbaufnahme der Walze',
    'storoller-effect': 'Für dekorative Struktureffekte',
    'sto-glattekelle-profi': 'Professionelles Glätten und Strukturieren'
  };

  var ZUBEHOER_REICHWEITE = {
    'kip-3808-washi-tape': '50 m pro Rolle',
    'sto-abdeckfolie-hdpe': '20–50 m² je nach Größe',
    'sto-abdeckvlies': 'ca. 25 m² pro Rolle',
    'stoprim-gt': 'ca. 100–150 m² pro 15 L',
    'stoprim-silikat': 'ca. 70–100 m² pro 10 L',
    'sto-hydrogrund': 'ca. 40–100 m² pro 10 L',
    'stoprim-in-basic': 'ca. 65–100 m² pro 10 L',
    'stoprep-contact': 'ca. 5–8 m² pro 25 kg',
    'stoprep-sil': 'ca. 5–7 m² pro 25 kg',
    'stoprim-micro': 'ca. 20–30 m² pro 3 L',
    'stoprim-sol-gt': 'ca. 80–120 m² pro 10 L',
    'stoprim-lp': 'ca. 100–200 m² pro 10 L',
    'stoprep-isol-q': 'ca. 6–8 m² pro 25 kg',
    'stoprep-isol': 'ca. 6–8 m² pro 25 kg',
    'stoprim-sil-color': 'ca. 80–120 m² pro 10 L'
  };


  // ═══ HELPERS ═══

  function formatPrice(p) { return p.toFixed(2).replace('.', ',') + ' \u20AC'; }


  function escHtml(str) {
    // Regex statt textContent/innerHTML: Letzteres escapte keine Anfuehrungszeichen —
    // in Attributen (data-option="...") war das ein Ausbruchs-/XSS-Vektor.
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatAIText(text) {
    if (!text || typeof text !== 'string') return text || '';
    // Bold: **text** → <strong>text</strong>
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Bullet points: lines starting with "- "
    text = text.replace(/^- (.+)$/gm, '<span style="display:block;padding-left:12px;text-indent:-12px;">• $1</span>');
    // Double newlines → paragraph breaks
    text = text.replace(/\n\n/g, '<br><br>');
    // Single newlines → line breaks
    text = text.replace(/\n/g, '<br>');
    return text;
  }

  // ═══ CONSTRUCTOR ═══

  function PB4(container) {
    this.container = container;
    this.apiEndpoint = container.getAttribute('data-api-endpoint') ||
      'https://sto-projektberater-v3.farbenbote.workers.dev/api/berater';
    this.thomasImage = container.getAttribute('data-thomas-image') || '';
    this.state = this.freshState();
    this.init();
    this.restoreResult();
  }

  // ── Session-Persistenz ──────────────────────────────────────────────
  // Vorher lebte der komplette Beratungszustand nur im Speicher: Ein Klick auf
  // einen empfohlenen Produktlink (gleicher Tab) oder ein Reload vernichtete
  // Empfehlung, Verbrauchsrechnung und Zubehoer-Bundle. Jetzt wird das Ergebnis
  // fuer 24 h in sessionStorage gehalten und beim Laden wiederhergestellt.
  var PERSIST_KEY = 'fb_pb4_result_v1';

  PB4.prototype.persistResult = function() {
    try {
      sessionStorage.setItem(PERSIST_KEY, JSON.stringify({
        t: Date.now(),
        resultData: this.state.resultData,
        category: this.state.category,
        apiCategory: this.state.apiCategory,
        aiDetectedCategory: this.state.aiDetectedCategory,
        treeAnswers: this.state.treeAnswers,
        summaryArea: this.state.summaryArea,
        dialogHistory: this.state.dialogHistory,
        sessionId: this.state.sessionId
      }));
    } catch (e) {}
  };

  PB4.prototype.clearPersisted = function() {
    try { sessionStorage.removeItem(PERSIST_KEY); } catch (e) {}
  };

  PB4.prototype.restoreResult = function() {
    var raw = null;
    try { raw = sessionStorage.getItem(PERSIST_KEY); } catch (e) {}
    if (!raw) return;
    var saved = null;
    try { saved = JSON.parse(raw); } catch (e) { this.clearPersisted(); return; }
    if (!saved || !saved.resultData || (Date.now() - (saved.t || 0)) > 86400000) {
      this.clearPersisted();
      return;
    }
    this.state.resultData = saved.resultData;
    this.state.category = saved.category;
    this.state.apiCategory = saved.apiCategory;
    this.state.aiDetectedCategory = saved.aiDetectedCategory || null;
    this.state.treeAnswers = saved.treeAnswers || [];
    this.state.summaryArea = saved.summaryArea || 30;
    this.state.dialogHistory = saved.dialogHistory || [];
    this.state.sessionId = saved.sessionId;
    this.state.hasResult = true;
    this.buildAndShowResult(saved.resultData);
    this.trackEvent('pb_result_restored');   // trackEvent puffert selbst
  };

  PB4.prototype.freshState = function() {
    return {
      currentScreen: 'screenStart',
      screenHistory: ['screenStart'],
      category: null,
      apiCategory: null,
      aiDetectedCategory: null,
      dialogHistory: [],
      treeStep: 0,
      treeAnswers: [],
      summaryArea: 30,
      pendingPhoto: null,
      isLoading: false,
      hasResult: false,
      resultData: null,
      loadingActive: false,
      resultReady: false,
      pendingResult: null,
      enrichedProducts: {},
      zubehoerItems: [],
      gestellteFragen: [],
      sessionId: null
    };
  };

  // ═══ INIT ═══

  PB4.prototype.init = function() {
    var self = this;

    document.getElementById('pbBackBtn').addEventListener('click', function() { self.goBack(); });

    document.querySelectorAll('.pb-cat-card').forEach(function(card) {
      card.addEventListener('click', function() {
        self.startTreeFlow(card.getAttribute('data-cat'), card.getAttribute('data-api'));
        self.trackEvent('pb_category_selected', { category: card.getAttribute('data-api') });
      });
    });

    var freitext = document.getElementById('pbFreitext');
    var sendBtn = document.getElementById('pbSendBtn');
    if (freitext && sendBtn) {
      this.syncSendBtn = function() {
        var hat = freitext.value.trim().length > 0;
        sendBtn.classList.toggle('enabled', hat);
        sendBtn.disabled = !hat;
      };
      this.syncSendBtn();
      freitext.addEventListener('input', this.syncSendBtn);
      // Browser-Formular-Restore (Reload) feuert kein input-Event
      window.addEventListener('pageshow', this.syncSendBtn);
      sendBtn.addEventListener('click', function() {
        if (freitext.value.trim()) self.startFreetextFlow(freitext.value.trim());
      });
      freitext.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.shiftKey && freitext.value.trim()) {
          e.preventDefault();
          self.startFreetextFlow(freitext.value.trim());
        }
      });
    }

    this.setupPhotoUpload();

    // Beispiel-Chips: senken die Huerde der leeren Textarea deutlich.
    document.querySelectorAll('[data-beispiel]').forEach(function(chip) {
      chip.addEventListener('click', function() {
        var text = chip.getAttribute('data-beispiel');
        if (freitext) { freitext.value = text; if (self.syncSendBtn) self.syncSendBtn(); }
        self.trackEvent('pb_beispiel_gewaehlt', { beispiel: (chip.textContent || '').trim().slice(0, 40) });
        self.startFreetextFlow(text);
      });
    });

    // CTAs weiter unten auf der Seite springen zurueck zur Konsole
    document.querySelectorAll('[data-pb-hoch]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var ziel = document.getElementById('pbFreitext');
        if (!ziel) return;
        ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() { ziel.focus({ preventScroll: true }); }, 350);
      });
    });

    this.setupTippAnimation();
    this.setupSticky();
    this.setupVideoModal();
    this.setupTonModal();

    document.querySelectorAll('.pb-faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.parentElement;
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.pb-faq-item').forEach(function(i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  };

  // ═══ VIDEO-BERATUNGS-MODAL ═══
  // Jeder Beratungs-Link im Berater oeffnet das Modal statt zu navigieren —
  // sonst verliert der Nutzer seine komplette Beratung, nur um einen Termin
  // zu machen. Calendly laedt erst auf Klick (Zwei-Klick, wie auf der LP).
  PB4.prototype.setupVideoModal = function() {
    var self = this;
    var modal = document.getElementById('pbVideoModal');
    if (!modal) return;
    var host = modal.querySelector('.pb-modal-embed');
    var ladeBtn = modal.querySelector('[data-modal-laden]');
    var letzterFokus = null;

    function schliessen() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (letzterFokus && letzterFokus.focus) letzterFokus.focus();
    }
    function oeffnen(quelle) {
      letzterFokus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      self.trackEvent('pb_videoberatung_modal', { quelle: quelle || 'unbekannt' });
      var zu = modal.querySelector('.pb-modal-close');
      if (zu) zu.focus();
    }

    // Alle Beratungs-CTAs im Tool abfangen (auch die dynamisch erzeugten im
    // Ergebnis, Chat-Fallback und Fehler-Screen) — Delegation in der Capture-Phase.
    this.container.addEventListener('click', function(e) {
      var link = e.target.closest ? e.target.closest('a[href="/pages/videoberatung"]') : null;
      if (!link) return;
      e.preventDefault();
      oeffnen(link.getAttribute('data-beratung-quelle'));
    });

    modal.querySelectorAll('[data-modal-schliessen]').forEach(function(el) {
      el.addEventListener('click', schliessen);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) schliessen();
    });

    if (ladeBtn && host) {
      ladeBtn.addEventListener('click', function() {
        if (host.getAttribute('data-geladen')) return;
        host.setAttribute('data-geladen', '1');
        ladeBtn.closest('.pb-modal-platzhalter').hidden = true;
        var widget = document.createElement('div');
        widget.className = 'calendly-inline-widget';
        widget.setAttribute('data-url', host.getAttribute('data-calendly'));
        host.appendChild(widget);
        var sc = document.createElement('script');
        sc.src = 'https://assets.calendly.com/assets/external/widget.js';
        sc.async = true;
        document.body.appendChild(sc);
        self.trackEvent('beratung_termin_klick', { quelle: 'projektberater_modal' });
      });
    }
  };

  // ═══ BUEHNEN-DETAILS ═══

  // Tippender Platzhalter: zeigt konkret, was man eingeben kann. Genau der
  // Punkt, an dem Nutzer vor einer leeren Textarea sonst abspringen.
  PB4.prototype.setupTippAnimation = function() {
    var feld = document.getElementById('pbFreitext');
    if (!feld) return;
    var saetze = [
      'Ich will mein Wohnzimmer streichen — Raufaser, ca. 25 m² …',
      'Meine Fassade hat Algen auf der Nordseite …',
      'Kinderzimmer: abwaschbar und schadstoffgeprüft …'
    ];
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      feld.placeholder = saetze[0];
      return;
    }
    var si = 0, ci = 0, tippen = true;
    function tick() {
      if (document.activeElement === feld || feld.value) { feld.placeholder = saetze[0]; return; }
      var satz = saetze[si];
      if (tippen) {
        ci++; feld.placeholder = satz.slice(0, ci);
        if (ci >= satz.length) { tippen = false; setTimeout(tick, 1800); return; }
        setTimeout(tick, 34);
      } else {
        ci -= 3;
        if (ci <= 0) { ci = 0; tippen = true; si = (si + 1) % saetze.length; }
        feld.placeholder = satz.slice(0, ci);
        setTimeout(tick, tippen ? 500 : 14);
      }
    }
    setTimeout(tick, 700);
  };

  // Sticky-CTA (mobil) zieht sich zurueck, wenn die Konsole ohnehin sichtbar ist.
  PB4.prototype.setupSticky = function() {
    var sticky = document.getElementById('pbSticky');
    var konsole = document.querySelector('.pb-konsole');
    if (!sticky || !konsole || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function(eintraege) {
      eintraege.forEach(function(e) { sticky.classList.toggle('zurueck', e.isIntersecting); });
    }, { threshold: .25 });
    io.observe(konsole);
  };

  // ═══ PHOTO UPLOAD ═══

  PB4.prototype.setupPhotoUpload = function() {
    var self = this;
    // Seit dem Redesign ist der Foto-Button in der Konsole der Einstieg; die
    // frueher grosse Dropzone (#pbPhotoUpload) ist optional geworden.
    var zone = document.getElementById('pbPhotoUpload');
    var toolbarBtn = document.getElementById('pbToolbarPhotoBtn');
    if (!zone && !toolbarBtn) return;

    var inp = document.createElement('input');
    inp.type = 'file'; inp.accept = 'image/*';
    inp.style.display = 'none';
    // NICHT in #pbPhotoUpload haengen — processPhoto ueberschreibt dessen
    // innerHTML und wuerde den Input aus dem DOM loesen.
    (toolbarBtn || zone).parentNode.appendChild(inp);
    this.photoInput = inp;

    if (zone) zone.addEventListener('click', function() { inp.click(); });
    if (toolbarBtn) {
      toolbarBtn.addEventListener('click', function() { inp.click(); });
    }

    // X-Button am Thumbnail: Foto entfernen
    var thumbRemove = document.getElementById('pbPhotoThumbRemove');
    if (thumbRemove) {
      thumbRemove.addEventListener('click', function(e) {
        e.stopPropagation();
        self.state.pendingPhoto = null;
        inp.value = '';
        var thumb = document.getElementById('pbPhotoThumb');
        if (thumb) thumb.style.display = 'none';
        if (toolbarBtn) toolbarBtn.style.color = '';
        var zone = document.getElementById('pbPhotoUpload');
        if (zone) {
          zone.innerHTML =
            '<div class="pb-photo-upload-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg></div>' +
            '<div class="pb-photo-upload-text"><strong>Foto hochladen f\u00fcr pr\u00e4zisere Empfehlung</strong>' +
            '<span>KI-Thomas analysiert Untergrund und Zustand vom Bild</span></div>';
        }
      });
    }

    inp.addEventListener('change', function() {
      if (!inp.files || !inp.files[0]) return;
      var file = inp.files[0];
      if (file.size > 5 * 1024 * 1024) { alert('Bild ist zu groß (max. 5 MB)'); return; }
      self.trackEvent('pb_photo_added');
      self.processPhoto(file);
    });
  };

  PB4.prototype.processPhoto = function(file) {
    var self = this;
    var reader = new FileReader();
    reader.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var canvas = document.createElement('canvas');
        var maxSize = 800;
        var w = img.width, h = img.height;
        if (w > maxSize || h > maxSize) {
          if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; }
          else { w = Math.round(w * maxSize / h); h = maxSize; }
        }
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        self.state.pendingPhoto = canvas.toDataURL('image/jpeg', 0.8);
        // Thumbnail in der Toolbar anzeigen
        var thumbImg = document.getElementById('pbPhotoThumbImg');
        var thumb = document.getElementById('pbPhotoThumb');
        if (thumbImg && thumb) {
          thumbImg.src = self.state.pendingPhoto;
          thumb.style.display = 'flex';
        }
        // Toolbar-Button gelb einfärben als Bestätigung
        var toolbarBtn = document.getElementById('pbToolbarPhotoBtn');
        if (toolbarBtn) toolbarBtn.style.color = 'var(--accent)';
        // pbPhotoUpload Zone (weiter unten) ebenfalls aktualisieren
        var zone = document.getElementById('pbPhotoUpload');
        if (zone) {
          zone.innerHTML =
            '<div class="pb-photo-upload-icon" style="color:var(--success);">\u2713</div>' +
            '<div class="pb-photo-upload-text"><strong>Foto hochgeladen</strong>' +
            '<span>Wird bei der Analyse berücksichtigt</span></div>';
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  // ═══ NAVIGATION ═══

  // Redesign 2026-08-19: Die Buehne (#pbBuehne) ist der Einstieg, der
  // Arbeitsbereich (#pbArbeit) uebernimmt, sobald eine Beratung laeuft.
  // screenStart existiert nicht mehr als eigener Screen — es IST die Buehne.
  PB4.prototype.zeigeBuehne = function(anzeigen) {
    var buehne = document.getElementById('pbBuehne');
    var arbeit = document.getElementById('pbArbeit');
    if (!buehne || !arbeit) return;
    var wechsel = buehne.hidden === anzeigen; // Zustand aendert sich wirklich
    buehne.hidden = !anzeigen;
    arbeit.hidden = anzeigen;
    var sticky = document.getElementById('pbSticky');
    if (sticky) sticky.style.display = anzeigen ? '' : 'none';

    // Beim Umschalten schrumpft/waechst das Dokument um mehr als eine
    // Bildschirmhoehe. Ohne Scroll-Korrektur landet der Nutzer (v.a. mobil,
    // wo die Kategorien untereinander stehen) im Footer und denkt, nichts sei
    // passiert. Ziel ist der Anfang des jeweils sichtbaren Bereichs.
    if (wechsel) {
      var ziel = anzeigen ? buehne : arbeit;
      var oben = ziel.getBoundingClientRect().top + window.pageYOffset;
      var glatt = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: Math.max(0, oben - 8), behavior: glatt ? 'smooth' : 'auto' });
    }
  };

  PB4.prototype.goTo = function(screenId) {
    this.zeigeBuehne(screenId === 'screenStart');
    this.container.querySelectorAll('.pb-screen').forEach(function(s) {
      s.classList.remove('active', 'slide-left', 'slide-right');
    });
    var target = document.getElementById(screenId);
    if (target) {
      target.classList.add('active', 'slide-left');
      // Screenreader/Tastatur: Fokus auf den neuen Screen setzen, sonst bleibt er
      // auf dem entfernten Button des vorherigen Screens haengen.
      if (screenId !== 'screenStart') {
        target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    this.state.currentScreen = screenId;
    if (this.state.screenHistory[this.state.screenHistory.length - 1] !== screenId) {
      this.state.screenHistory.push(screenId);
    }
    this.updateHeader(screenId);
    this.updateProgress(screenId);
    this.updateBackBtn(screenId);
    this.updateFooter(screenId);
  };

  PB4.prototype.goBack = function() {
    if (this.state.screenHistory.length <= 1) return;
    this.state.screenHistory.pop();
    var prev = this.state.screenHistory[this.state.screenHistory.length - 1];

    // Transiente Screens sind keine Rueckkehr-Ziele: screenLoading laeuft nicht
    // mehr (loadingActive ist false) und waere eine Sackgasse ohne Ausweg.
    while (this.state.screenHistory.length > 1 &&
           (prev === 'screenLoading' || prev === 'screenError')) {
      this.state.screenHistory.pop();
      prev = this.state.screenHistory[this.state.screenHistory.length - 1];
    }
    if (prev === 'screenLoading' || prev === 'screenError') prev = 'screenStart';

    // Zustand aus der ZIEL-ID rekonstruieren statt schrittweise dekrementieren —
    // die alte Heuristik lief bei Sprung aus der Zusammenfassung aus dem Tritt und
    // liess Alt-Antworten stehen (spaeter TypeError in showSummaryScreen).
    if (prev.indexOf('screenTree') === 0) {
      var n = parseInt(prev.slice('screenTree'.length), 10);
      if (!isNaN(n)) {
        this.state.treeStep = n;
        this.state.treeAnswers.length = Math.min(this.state.treeAnswers.length, n);
      }
    } else if (prev === 'screenStart') {
      this.state.treeStep = 0;
      this.state.treeAnswers = [];
    }
    this.goTo(prev);
  };

  PB4.prototype.updateHeader = function(screenId) {
    var t = document.getElementById('pbHeaderTitle');
    var s = document.getElementById('pbHeaderSub');
    if (!t || !s) return;

    if (screenId === 'screenStart') {
      t.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0606/1821/1516/files/unnamed-1.jpg?v=1773089968" alt="Sto" class="pb-sto-logo-circle"> Projektberater'; s.textContent = 'Kostenlose Analyse in 2\u20133 Minuten';
    } else if (screenId === 'screenSummary') {
      t.textContent = 'Zusammenfassung'; s.textContent = 'Prüfe deine Angaben';
    } else if (screenId === 'screenLoading') {
      t.textContent = 'Analyse läuft...'; s.textContent = 'KI-Thomas prüft die Sto-Systemlogik';
    } else if (screenId === 'screenResult') {
      t.textContent = 'Deine Empfehlung'; s.textContent = 'Frag KI-Thomas direkt, wenn du Fragen hast';
    } else if (screenId === 'screenAIQuestion') {
      // Vorher fiel dieser Screen durch alle Zweige — die Leiste blieb dauerhaft
      // auf "Analyse läuft...", obwohl laengst eine Rueckfrage angezeigt wurde.
      t.textContent = 'Kurze Rückfrage'; s.textContent = 'Damit die Empfehlung wirklich passt';
    } else if (screenId === 'screenError') {
      t.textContent = 'Das hat nicht geklappt'; s.textContent = 'Versuch es erneut oder sprich mit uns';
    } else if (screenId.indexOf('screenTree') === 0) {
      var tree = DECISION_TREES[this.state.apiCategory];
      if (tree && tree[this.state.treeStep]) {
        var q = tree[this.state.treeStep];
        var rem = tree.length - this.state.treeStep;
        t.textContent = q.label;
        s.textContent = rem > 1 ? 'Noch ' + rem + ' Fragen' : 'Letzte Frage';
      }
    }
  };

  PB4.prototype.updateProgress = function(screenId) {
    var dots = document.querySelectorAll('.pb-progress-dot');
    var label = document.getElementById('pbProgressLabel');
    if (!dots.length || !label) return;
    // 4 Schritte, wie die Landing-Sektion verspricht: Start -> Details ->
    // Zusammenfassung -> Ergebnis. Alle Baumfragen zaehlen als EIN Schritt,
    // sonst springt der Fortschritt je nach Kategorie (3-4 Fragen) rueckwaerts.
    var idx = 0;
    if (screenId === 'screenStart') idx = 0;
    else if (screenId.indexOf('screenTree') === 0 || screenId === 'screenAIQuestion') idx = 1;
    else if (screenId === 'screenSummary') idx = 2;
    else if (screenId === 'screenLoading' || screenId === 'screenResult') idx = 3;

    dots.forEach(function(dot, i) {
      dot.classList.remove('active', 'done');
      if (i < idx) dot.classList.add('done');
      else if (i === idx) dot.classList.add('active');
    });
    if (screenId === 'screenResult') label.textContent = 'Fertig';
    else if (screenId === 'screenLoading') label.textContent = 'Analyse...';
    else if (screenId === 'screenError') label.textContent = '';
    else label.textContent = 'Schritt ' + (idx + 1) + ' von 4';
  };

  PB4.prototype.updateBackBtn = function(screenId) {
    var btn = document.getElementById('pbBackBtn');
    if (!btn) return;
    btn.classList.toggle('visible', ['screenStart', 'screenLoading', 'screenResult'].indexOf(screenId) < 0);
  };

  PB4.prototype.updateFooter = function(screenId) {
    var footer = document.getElementById('pbWizardFooter');
    if (!footer) return;
    var self = this;
    if (screenId === 'screenResult') {
      // Im Freitext-Flow existiert kein Summary-Screen — der Button fuehrte dort
      // in einen leeren Wizard. Nur anbieten, wenn das Ziel wirklich existiert.
      var hatSummary = this.state.category !== 'Freitext' && (this.state.treeAnswers || []).length > 0 && !!document.getElementById('screenSummary');
      footer.innerHTML =
        '<div class="pb-result-footer">' +
        '<button class="pb-footer-btn" id="btnRestart">Neues Projekt</button>' +
        (hatSummary ? '<button class="pb-footer-btn" id="btnChange">Angaben ändern</button>' : '') +
        '</div>';
      footer.querySelector('#btnRestart').addEventListener('click', function() { self.restart(); });
      var chg = footer.querySelector('#btnChange');
      if (chg) chg.addEventListener('click', function() { self.goTo('screenSummary'); });
    } else if (screenId === 'screenLoading') {
      footer.innerHTML = '<span style="font-size:11px;color:var(--ink-muted);">Ergebnis wird berechnet...</span>';
    } else {
      footer.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
        '<span>Kostenlos und unverbindlich \u00B7 Deine Daten bleiben geschützt</span>';
    }
  };

  PB4.prototype.restart = function() {
    this.clearPersisted();
    this.state = this.freshState();
    var grid = document.getElementById('pbArbeitGrid');
    if (grid) grid.classList.remove('hat-produkte');
    var prod = document.getElementById('pbProducts');
    if (prod) { prod.classList.remove('active'); prod.innerHTML = ''; }
    this.container.querySelectorAll('.pb-screen-dynamic').forEach(function(s) { s.remove(); });
    var ft = document.getElementById('pbFreitext');
    if (ft) ft.value = '';
    if (typeof this.syncSendBtn === 'function') this.syncSendBtn();
    // Foto-Status zuruecksetzen (Thumbnail + Button-Faerbung sind die Anzeige)
    var thumb = document.getElementById('pbPhotoThumb');
    if (thumb) thumb.style.display = 'none';
    var fotoBtn = document.getElementById('pbToolbarPhotoBtn');
    if (fotoBtn) fotoBtn.style.color = '';
    // Ohne Reset feuert die Auswahl DERSELBEN Datei kein change-Event mehr —
    // der Upload waere still wirkungslos.
    if (this.photoInput) this.photoInput.value = '';
    this.goTo('screenStart');
  };

  // ═══ TREE FLOW ═══

  PB4.prototype.startTreeFlow = function(catTitle, apiCat) {
    this.state.category = catTitle;
    this.state.apiCategory = apiCat;
    this.state.treeStep = 0;
    this.state.treeAnswers = [];
    this.state.dialogHistory = [];
    this.state.sessionId = 'ses_' + crypto.randomUUID();

    var tree = DECISION_TREES[apiCat];
    if (!tree) {
      this.state.dialogHistory.push({ role: 'user', content: 'Ich möchte ' + catTitle + ' bearbeiten.' });
      this.showSummaryScreen();
      return;
    }
    this.showTreeQuestion(0);
  };

  PB4.prototype.showTreeQuestion = function(step) {
    var self = this;
    var tree = DECISION_TREES[this.state.apiCategory];
    if (!tree || !tree[step]) return;
    var q = tree[step];
    var remaining = tree.length - step;
    var screenId = 'screenTree' + step;

    var old = document.getElementById(screenId);
    if (old && old.classList.contains('pb-screen-dynamic')) old.remove();

    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = screenId;

    var crumbs = '<div class="pb-breadcrumb"><span class="pb-breadcrumb-chip">' +
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M20 6 9 17l-5-5"/></svg> ' +
      escHtml(this.state.category) + '</span>';
    for (var i = 0; i < this.state.treeAnswers.length; i++) {
      crumbs += '<span class="pb-breadcrumb-sep">\u2192</span><span class="pb-breadcrumb-chip">' +
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M20 6 9 17l-5-5"/></svg> ' +
        escHtml(this.state.treeAnswers[i]) + '</span>';
    }
    crumbs += '</div>';

    var helpText = remaining > 1
      ? 'Noch ' + remaining + ' Fragen für die beste Empfehlung'
      : 'Letzte Frage \u2014 dann berechnen wir dein Ergebnis';

    var html = crumbs +
      '<div class="pb-question-label">' + escHtml(q.label) + '</div>' +
      '<div class="pb-question-title">' + escHtml(q.text) + '</div>' +
      '<div class="pb-question-help">' + helpText + '</div>' +
      '<div class="pb-options">';
    q.options.forEach(function(opt) {
      html += '<button class="pb-option" data-option="' + escHtml(opt) + '"><span>' + escHtml(opt) + '</span><span class="pb-option-arrow" aria-hidden="true">\u203A</span></button>';
    });
    html += '</div>' +
      '<div class="pb-divider" style="margin-top:16px;"><div class="pb-divider-line"></div>' +
      '<span class="pb-divider-text">Oder beschreibe es</span><div class="pb-divider-line"></div></div>' +
      '<div class="pb-inline-input"><input class="pb-inline-field" type="text" placeholder="Freitext-Antwort...">' +
      '<button class="pb-inline-submit">Weiter</button></div>';

    screen.innerHTML = html;
    document.getElementById('pbWizardBody').appendChild(screen);

    screen.querySelectorAll('.pb-option').forEach(function(btn) {
      btn.addEventListener('click', function() {
        self.handleTreeAnswer(btn.getAttribute('data-option'), step);
      });
    });
    var inlineField = screen.querySelector('.pb-inline-field');
    var inlineSub = screen.querySelector('.pb-inline-submit');
    if (inlineField && inlineSub) {
      inlineSub.addEventListener('click', function() {
        if (inlineField.value.trim()) self.handleTreeAnswer(inlineField.value.trim(), step);
      });
      inlineField.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && inlineField.value.trim()) self.handleTreeAnswer(inlineField.value.trim(), step);
      });
    }

    this.state.treeStep = step;
    this.goTo(screenId);
  };

  PB4.prototype.handleTreeAnswer = function(answer, step) {
    this.state.treeAnswers.push(answer);
    this.trackEvent('pb_tree_step_answered', { category: this.state.apiCategory, step: step + 1 });
    var tree = DECISION_TREES[this.state.apiCategory];
    if (step + 1 < tree.length) {
      this.showTreeQuestion(step + 1);
    } else {
      this.showSummaryScreen();
    }
  };

  // ═══ SUMMARY ═══

  PB4.prototype.showSummaryScreen = function() {
    var self = this;
    var old = document.getElementById('screenSummary');
    if (old) old.remove();

    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = 'screenSummary';

    var tree = DECISION_TREES[this.state.apiCategory];
    var html = '<div class="pb-summary-title">Dein Projekt</div>' +
      '<div class="pb-summary-sub">Prüfe deine Angaben und gib die Fläche ein.</div>' +
      '<div class="pb-summary-rows">' +
      '<div class="pb-summary-row"><span class="pb-summary-label">Bereich</span>' +
      '<span class="pb-summary-value">' + escHtml(this.state.category) + '</span></div>';

    if (tree) {
      var anzahl = Math.min(this.state.treeAnswers.length, tree.length);
      for (var i = 0; i < anzahl; i++) {
        html += '<div class="pb-summary-row"><span class="pb-summary-label">' + escHtml(tree[i].label) + '</span>' +
          '<span class="pb-summary-value">' + escHtml(this.state.treeAnswers[i]) + '</span></div>';
      }
    }

    html += '<div class="pb-summary-row"><span class="pb-summary-label">Fläche</span>' +
      '<div class="pb-area-input"><input type="number" class="pb-area-field" id="pbAreaField" value="30" min="1" max="999">' +
      '<span class="pb-area-unit">m\u00B2</span></div></div></div>' +
      '<button class="pb-cta" id="pbSummaryCta">Passende Produkte finden ' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>';

    screen.innerHTML = html;
    document.getElementById('pbWizardBody').appendChild(screen);

    this.trackEvent('pb_summary_shown', { category: this.state.apiCategory });
    screen.querySelector('#pbSummaryCta').addEventListener('click', function() {
      self.state.summaryArea = parseInt(document.getElementById('pbAreaField').value) || 30;
      self.submitTreeSummary();
    });

    this.goTo('screenSummary');
  };

  // ═══ API ═══

  PB4.prototype.submitTreeSummary = function() {
    var tree = DECISION_TREES[this.state.apiCategory];
    var parts = ['Bereich: ' + this.state.category];
    if (tree) {
      var max = Math.min(this.state.treeAnswers.length, tree.length);
      for (var i = 0; i < max; i++) {
        parts.push(tree[i].label + ': ' + this.state.treeAnswers[i]);
      }
    }
    parts.push('Fläche: ' + this.state.summaryArea + ' m\u00B2');
    this.state.dialogHistory = [{ role: 'user', content: parts.join('\n') }];
    this.showLoadingScreen(true);      // Schlussanalyse
    this.sendToWorker(true);
  };

  PB4.prototype.startFreetextFlow = function(text) {
    this.state.category = 'Freitext';
    this.state.apiCategory = 'auto';
    // Reste eines abgebrochenen Tree-Flows raeumen — sonst zeigt der Ergebnis-
    // Footer eine veraltete Zusammenfassung an, deren CTA die Freitext-Eingabe
    // ueberschreiben wuerde.
    this.state.treeAnswers = [];
    this.state.treeStep = 0;
    this.container.querySelectorAll('.pb-screen-dynamic').forEach(function(sc) {
      if (sc.id === 'screenSummary' || sc.id.indexOf('screenTree') === 0) sc.remove();
    });
    this.state.sessionId = 'ses_' + crypto.randomUUID();
    this.state.dialogHistory = [{ role: 'user', content: text }];
    this.trackEvent('pb_freetext_submitted');
    this.showLoadingScreen(false);     // evtl. folgen noch Rueckfragen
    this.sendToWorker(false);
  };

  // Conversion-Attribution: Session als Cart-Attribut hinterlegen, sobald die Beratung
  // startet — nicht erst beim ATC im Widget. Sonst zählen nur Direktkäufe im Berater,
  // und jeder Kunde, der über den Produktlink zur PDP geht, fehlt in der Statistik.
  // Idempotent pro Session (neue Beratung = neue sessionId = erneut setzen).
  PB4.prototype.setCartAttribute = function() {
    if (!this.state.sessionId || this.cartAttributeSessionId === this.state.sessionId) return;
    this.cartAttributeSessionId = this.state.sessionId;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { '_projektberater_session': this.state.sessionId } })
    }).catch(function() {});
  };

  PB4.prototype.sendToWorker = function(skipDiscovery) {
    var self = this;
    this.state.lastSkipDiscovery = skipDiscovery;
    this.setCartAttribute();
    var payload = {
      category: this.state.apiCategory || 'auto',
      dialog_history: this.state.dialogHistory,
      quick_mode: false,
      session_id: this.state.sessionId,
      answers: this.state.treeAnswers || [],
      mode: skipDiscovery ? 'tree' : 'ai'
    };
    if (skipDiscovery) payload.skip_discovery = true;
    if (this.state.pendingPhoto) payload.photo_base64 = this.state.pendingPhoto;
    // Die in der Discovery erkannte Kategorie zurueckgeben — sonst verliert der
    // Worker sie in der Empfehlungsphase (das Frontend pusht nur Fragetexte in
    // die History) und mischt fremde Kategorien in die Produktliste
    // (Vorfall 2026-08-19: Kinderstuhl -> Wandfarben-Empfehlung).
    if (this.state.aiDetectedCategory) payload.detected_category = this.state.aiDetectedCategory;

    fetch(this.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.type === 'result') {
        self.state.resultData = data.result;
        self.state.resultReady = true;
        self.state.pendingResult = data.result;
        self.persistResult();
        self.trackEvent('pb_recommendations_received', { products_count: (data.result.products || []).length });
        if (!self.state.loadingActive) self.buildAndShowResult(data.result);
      } else if (data.type === 'question') {
        self.state.loadingActive = false;
        if (data.detected_category) self.state.aiDetectedCategory = data.detected_category;
        self.showAIQuestion(data.question);
      } else if (data.type === 'error') {
        self.showError(data.error || 'Ein Fehler ist aufgetreten.');
      }
    })
    .catch(function(err) {
      console.error('PB4 API Error:', err);
      self.showError('Verbindungsfehler. Bitte versuche es erneut.');
    });
  };

  // ═══ LOADING ═══

  // voll=true nur fuer die echte Schlussanalyse. Bei Zwischen-Rueckfragen wirkte
  // der grosse Analyse-Screen ("Materialverbrauch wird berechnet") nach JEDEM
  // Klick — und versprach etwas, das erst am Ende passiert.
  PB4.prototype.showLoadingScreen = function(voll) {
    var self = this;
    this.state.loadingVoll = !!voll;
    var old = document.getElementById('screenLoading');
    if (old) old.remove();

    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = 'screenLoading';

    var html;
    if (voll) {
      html = '<div class="pb-loading-center"><div class="pb-loading-pulse"></div>' +
        '<div class="pb-loading-title">Projekt wird analysiert</div>' +
        '<div class="pb-loading-sub">Optimale Lösung wird ermittelt</div>' +
        '<div class="pb-loading-steps" id="pbLoadingSteps">';
      LOADING_STEPS.forEach(function(step, i) {
        html += '<div class="pb-loading-step" data-idx="' + i + '"><div class="pb-loading-check">\u2713</div><span>' + step + '</span></div>';
      });
      html += '</div>' +
        '<div class="pb-loading-counter"><span id="pbLoadingCount">0</span> von ' + KATALOG_GROESSE + ' Produkten geprüft</div>' +
        '<div class="pb-loading-line"><div class="pb-loading-line-fill" id="pbLoadingBar"></div></div></div>';
    } else {
      // Leichter Zustand fuer Zwischenfragen
      html = '<div class="pb-loading-center pb-loading-center--leicht">' +
        '<div class="pb-denkt"><span></span><span></span><span></span></div>' +
        '<div class="pb-loading-title">KI-Thomas denkt nach</div>' +
        '<div class="pb-loading-sub">Einen Moment — ich prüfe deine Angaben</div></div>';
    }
    screen.innerHTML = html;
    document.getElementById('pbWizardBody').appendChild(screen);

    // Alte Empfehlung raeumen: sonst steht links die verworfene Liste mit
    // funktionierenden Warenkorb-Buttons, waehrend rechts neu gerechnet wird.
    var altProd = document.getElementById('pbProducts');
    if (altProd) { altProd.classList.remove('active'); altProd.innerHTML = ''; }
    var altGrid = document.getElementById('pbArbeitGrid');
    if (altGrid) altGrid.classList.remove('hat-produkte');
    this.state.zubehoerItems = [];

    this.state.loadingActive = true;
    this.state.resultReady = false;
    this.state.pendingResult = null;
    // Generationszaehler: entwertet Safety-Timer aelterer Loading-Screens —
    // sonst brach der 30-s-Timer des ERSTEN Laufs einen laufenden Retry ab.
    this.state.loadingGen = (this.state.loadingGen || 0) + 1;
    this.goTo('screenLoading');

    this.runLoadingAnimation();
  };

  PB4.prototype.runLoadingAnimation = function() {
    var self = this;
    var steps = document.querySelectorAll('#pbLoadingSteps .pb-loading-step');
    var bar = document.getElementById('pbLoadingBar');
    var countEl = document.getElementById('pbLoadingCount');
    steps.forEach(function(s) { s.classList.remove('done'); });
    if (bar) bar.style.width = '0%';

    var gen = this.state.loadingGen;
    var startZeit = Date.now();

    // Die ersten Schritte laufen zeitgesteuert, der LETZTE erst, wenn das
    // Ergebnis wirklich da ist — vorher standen alle Haken auf gruen, waehrend
    // der Nutzer noch wartete.
    var offen = steps.length - 1;
    for (var i = 0; i < offen; i++) {
      (function(idx) {
        setTimeout(function() {
          if (self.state.loadingGen === gen && steps[idx]) steps[idx].classList.add('done');
        }, 700 + idx * 1100);
      })(i);
    }

    // Zaehler: visualisiert die Katalog-Suche und verkuerzt die gefuehlte
    // Wartezeit. Zielwert ist die echte Produktzahl des Shops (Section-Setting).
    function tick() {
      if (self.state.loadingGen !== gen || !self.state.loadingActive) return;
      var vergangen = Date.now() - startZeit;

      if (self.state.resultReady) {
        // Endspurt: schnell auf 100 % und den letzten Haken setzen
        if (steps.length) steps[steps.length - 1].classList.add('done');
        if (countEl) countEl.textContent = KATALOG_GROESSE;
        if (bar) bar.style.width = '100%';
        self.state.loadingActive = false;
        var result = self.state.pendingResult;
        setTimeout(function() { if (result) self.buildAndShowResult(result); }, 380);
        return;
      }

      // Asymptotisch bis 92 % — wirkt zuegig, laeuft aber nie voll, solange
      // nichts da ist (kein "fertig", das keins ist).
      var anteil = 1 - Math.exp(-vergangen / 7000);
      anteil = Math.min(0.92, anteil);
      if (bar) bar.style.width = Math.round(anteil * 100) + '%';
      if (countEl) countEl.textContent = Math.round(anteil * KATALOG_GROESSE);
      setTimeout(tick, 90);
    }
    setTimeout(tick, 200);

    // Timeout safety, zweistufig (nur fuer die eigene Generation gueltig).
    // Vorher brach der 45-s-Timer hart mit Fehlermeldung ab, obwohl die
    // Antwort oft 1-2 s spaeter eintraf — der Fehler "ueberholte" das
    // Ergebnis. Jetzt: bei 45 s nur ein beruhigender Hinweis, der Lauf
    // geht weiter; erst bei 90 s der echte Fehler-Screen.
    setTimeout(function() {
      if (self.state.loadingGen === gen && self.state.loadingActive && !self.state.resultReady) {
        var center = document.querySelector('#screenLoading .pb-loading-center');
        if (center && !center.querySelector('.pb-loading-langsam')) {
          var hinweis = document.createElement('div');
          hinweis.className = 'pb-loading-langsam';
          hinweis.textContent = 'Dauert gerade etwas l\u00e4nger als \u00fcblich \u2014 ich bin noch dran \u2026';
          center.appendChild(hinweis);
        }
      }
    }, 45000);
    setTimeout(function() {
      if (self.state.loadingGen === gen && self.state.loadingActive && !self.state.resultReady) {
        self.state.loadingActive = false;
        self.showError('Die Analyse dauert zu lange. Bitte versuche es erneut.');
      }
    }, 90000);
  };

  // ═══ AI QUESTION (freetext follow-up) ═══

  PB4.prototype.showAIQuestion = function(question) {
    var self = this;
    var old = document.getElementById('screenAIQuestion');
    if (old) old.remove();

    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = 'screenAIQuestion';

    var qText = typeof question === 'string' ? question : (question.text || '');
    var html = '<div class="pb-question-label">KI-Thomas fragt</div>' +
      '<div class="pb-question-title">' + formatAIText(escHtml(qText)) + '</div>';
    if (question.help_text) html += '<div class="pb-question-help">' + formatAIText(escHtml(question.help_text)) + '</div>';

    if (question.options && question.options.length) {
      html += '<div class="pb-options">';
      question.options.forEach(function(opt) {
        var optText = typeof opt === 'string' ? opt : opt.text;
        html += '<button class="pb-option" data-option="' + escHtml(optText) + '"><span>' + escHtml(optText) + '</span><span class="pb-option-arrow" aria-hidden="true">\u203A</span></button>';
      });
      html += '</div>';
    }
    html += '<div class="pb-divider" style="margin-top:16px;"><div class="pb-divider-line"></div>' +
      '<span class="pb-divider-text">Oder beschreibe es</span><div class="pb-divider-line"></div></div>' +
      '<div class="pb-inline-input"><input class="pb-inline-field" type="text" placeholder="Deine Antwort...">' +
      '<button class="pb-inline-submit">Weiter</button></div>';

    screen.innerHTML = html;
    document.getElementById('pbWizardBody').appendChild(screen);

    screen.querySelectorAll('.pb-option').forEach(function(btn) {
      btn.addEventListener('click', function() { self.handleAIAnswer(btn.getAttribute('data-option')); });
    });
    var inF = screen.querySelector('.pb-inline-field');
    var inS = screen.querySelector('.pb-inline-submit');
    if (inF && inS) {
      inS.addEventListener('click', function() { if (inF.value.trim()) self.handleAIAnswer(inF.value.trim()); });
      inF.addEventListener('keydown', function(e) { if (e.key === 'Enter' && inF.value.trim()) self.handleAIAnswer(inF.value.trim()); });
    }
    this.goTo('screenAIQuestion');
  };

  PB4.prototype.handleAIAnswer = function(answer) {
    this.state.dialogHistory.push({ role: 'user', content: answer });
    this.showLoadingScreen(false);     // Zwischenschritt, keine Endanalyse
    this.sendToWorker(false);
  };

  // ═══ RESULT ═══

  PB4.prototype.buildAndShowResult = function(result) {
    var self = this;
    var old = document.getElementById('screenResult');
    if (old) old.remove();

    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = 'screenResult';

    var html = '<div class="pb-result-summary">';
    if (this.state.category) html += '<span class="pb-result-chip">' + escHtml(this.state.category) + '</span>';
    this.state.treeAnswers.forEach(function(a) { html += '<span class="pb-result-chip">' + escHtml(a) + '</span>'; });
    if (this.state.summaryArea) html += '<span class="pb-result-chip">' + this.state.summaryArea + ' m\u00B2</span>';
    html += '</div>';

    var botMsg = (result.malermeister_tipp ? formatAIText(escHtml(result.malermeister_tipp)) : '') ||
      'Deine <strong>persönliche Produktempfehlung</strong> steht! Links siehst du die passenden <strong>Sto-Produkte</strong> für dein Projekt.';

    // Quick-Replies: Startvorschlaege. Ab hier ersetzt renderChatChips() sie
    // kontextabhaengig — bei einer Gegenfrage durch passende ANTWORTEN.
    this.state.gestellteFragen = [];
    var chipsHtml = '<div class="pb-chat-chips" id="pbChatChips"></div>';

    html += '<div class="pb-chat"><div class="pb-chat-messages" id="pbChatMessages" aria-live="polite">' +
      '<div class="pb-chat-msg pb-chat-msg--bot"><strong>KI-Thomas:</strong> ' + botMsg + '</div></div>' +
      chipsHtml +
      '<div class="pb-chat-input"><input class="pb-chat-field" id="pbChatInput" type="text" placeholder="Oder frag mich etwas anderes …">' +
      '<button class="pb-chat-send" id="pbChatSend" aria-label="Frage senden">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button></div></div>';

    html += '<div class="pb-contact"><div class="pb-contact-avatar"><img src="' + esc(document.getElementById('projektberater-v4-app').getAttribute('data-team-image')) + '" alt="Das Farbenbote-Beratungsteam" width="36" height="36"></div>' +
      '<div class="pb-contact-text"><strong>Lieber mit echten Menschen sprechen?</strong><br>Unser Team schaut sich deine Fläche live per Video an.</div>' +
      '<div class="pb-contact-btns"><a class="pb-contact-btn pb-contact-btn--video" href="/pages/videoberatung" data-beratung-cta data-beratung-quelle="projektberater_result">Video-Beratung</a>' +
      '<a class="pb-contact-btn" href="tel:+4950429849001">Anrufen</a></div></div>';

    screen.innerHTML = html;
    document.getElementById('pbWizardBody').appendChild(screen);

    var chatSend = document.getElementById('pbChatSend');
    var chatInput = document.getElementById('pbChatInput');
    if (chatSend && chatInput) {
      chatSend.addEventListener('click', function() { self.handleChatSend(); });
      chatInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') self.handleChatSend(); });
    }
    this.renderChatChips(this.startChips(result));

    this.goTo('screenResult');
    this.buildProductCards(result);
  };

  // ── Quick-Replies ────────────────────────────────────────────────────
  // Startvorschlaege haengen davon ab, was in der Empfehlung wirklich steht
  // (z.B. Grundierung nur anbieten, wenn eine empfohlen wurde).
  PB4.prototype.startChips = function(result) {
    var chips = [];
    var hatGrundierung = !!(result && result.grundierung && result.grundierung.handle);
    if (hatGrundierung) chips.push('Warum brauche ich die Grundierung?');
    else chips.push('Brauche ich eine Grundierung?');
    chips.push('Wie lange muss das trocknen?');
    chips.push('Welche Walze passt dazu?');
    if (this.state.apiCategory === 'Fassaden') chips.push('Bei welchem Wetter streichen?');
    else chips.push('Reicht ein Anstrich?');
    return chips;
  };

  // typ 'frage' = der Nutzer fragt etwas, typ 'antwort' = er beantwortet eine
  // Gegenfrage von KI-Thomas. Bei Gegenfragen liefert der Worker die passenden
  // Optionen mit — die wurden im Chat bisher verworfen.
  PB4.prototype.renderChatChips = function(texte, typ) {
    var self = this;
    var box = document.getElementById('pbChatChips');
    if (!box) return;
    box.innerHTML = '';
    if (!texte || !texte.length) { box.hidden = true; return; }
    box.hidden = false;
    box.className = 'pb-chat-chips' + (typ === 'antwort' ? ' pb-chat-chips--antwort' : '');

    texte.slice(0, 5).forEach(function(t) {
      var text = (typeof t === 'string') ? t : (t.text || '');
      if (!text) return;
      if (self.state.gestellteFragen.indexOf(text) > -1) return;   // nie doppelt
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pb-chat-chip';
      b.textContent = text;
      b.addEventListener('click', function() {
        self.state.gestellteFragen.push(text);
        self.trackEvent('pb_chat_chip', { typ: typ || 'frage', text: text.slice(0, 40) });
        self.handleChatSend(text);
      });
      box.appendChild(b);
    });
    if (!box.children.length) box.hidden = true;
  };

  // ═══ PRODUCT CARDS ═══

  PB4.prototype.buildProductCards = function(result) {
    var self = this;
    var products = result.products || [];
    var el = document.getElementById('pbProducts');
    if (!el) return;
    var area = this.state.summaryArea || 30;
    var badgeLabelMap = { top: 'Top-Empfehlung', alt: 'Preis-Alternative', prem: 'Premium-Upgrade' };
    var badgeFallbacks = ['top', 'alt', 'prem'];

    var html = '<div class="pb-products-header">' +
      '<div class="pb-products-overline">Deine Empfehlung</div>' +
      '<div class="pb-products-title">' + products.length + ' Sto-Produkte für dein Projekt</div>' +
      '<div class="pb-products-sub">Basierend auf deinen Angaben \u00B7 ' + area + ' m\u00B2</div></div>';

    products.forEach(function(p, idx) {
      var badge = p.tier || badgeFallbacks[idx] || 'alt';
      var badgeLabel = badgeLabelMap[badge] || 'Empfehlung';
      var isTop = badge === 'top';
      var handle = p.handle || '';

      html += '<div class="pb-product-card' + (isTop ? ' pb-product-card--top' : '') + '" data-handle="' + handle + '">';
      html += '<div class="pb-badge pb-badge--' + badge + '">' + badgeLabel + '</div>';
      html += '<div class="pb-product-top">';
      html += '<div class="pb-product-img" data-handle="' + handle + '">' +
        '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></div>';
      html += '<div class="pb-product-info">';
      html += '<div class="pb-product-name"><a href="/products/' + handle + '" target="_blank" rel="noopener">' + escHtml(p.name || handle) + '</a><span class="pb-sto-brand">Sto</span></div>';

      html += '<div class="pb-product-reason">' + formatAIText(escHtml(p.reason || '')) + '</div></div></div>';

      if (p.pros && p.pros.length) {
        html += '<div class="pb-product-tags">';
        p.pros.forEach(function(t) { html += '<span class="pb-product-tag pb-product-tag--pro">+ ' + escHtml(t) + '</span>'; });
        if (p.cons) { p.cons.forEach(function(t) { html += '<span class="pb-product-tag pb-product-tag--con">\u2212 ' + escHtml(t) + '</span>'; }); }
        html += '</div>';
      }

      if (isTop && result.malermeister_tipp) {
        html += '<div class="pb-thomas-tipp"><div class="pb-thomas-tipp-avatar"><img src="https://cdn.shopify.com/s/files/1/0606/1821/1516/files/thomas-standorte-sto.jpg?v=1773051448" alt="Thomas" width="32" height="32"></div>' +
          '<div class="pb-thomas-tipp-content"><div class="pb-thomas-tipp-label">Tipp von KI-Thomas</div>' +
          '<div class="pb-thomas-tipp-text">' + formatAIText(escHtml(result.malermeister_tipp)) + '</div></div></div>';
      }

      html += '<div class="pb-product-purchase" data-handle="' + handle + '">' +
        '<div class="pb-product-calc"><div class="pb-product-price">Preis wird geladen...</div>' +
        '<div class="pb-product-quantity"></div></div>' +
        '<button class="pb-atc-btn" data-handle="' + handle + '" disabled>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        ' In den Warenkorb</button></div>';
      html += '</div>';
    });

    html += '<div class="pb-zubehoer" id="pbZubehoer"><div class="pb-zubehoer-header"><div class="pb-zubehoer-title">Passendes Zubehör</div></div>' +
      '<div class="pb-zubehoer-items" id="pbZubehoerItems">Wird geladen...</div></div>';

    if (result.system_empfehlung) {
      html += '<div class="pb-system-box"><div class="pb-system-icon">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg></div>' +
        '<div class="pb-system-text"><strong>Systemempfehlung:</strong> ' + formatAIText(escHtml(result.system_empfehlung)) + '</div></div>';
    }

    html += '<div class="pb-all-cart"><button class="pb-all-cart-btn" id="pbAllCartBtn">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
      ' Alles in den Warenkorb</button></div>';

    el.innerHTML = html;
    // Deterministisch statt requestAnimationFrame: beim Persistenz-Restore lief
    // der rAF-Callback nicht zuverlaessig (Seite noch im ersten Rendering) —
    // die Karten blieben dann dauerhaft auf opacity 0, also unsichtbar.
    void el.offsetHeight;                 // Reflow erzwingen, damit die Transition greift
    el.classList.add('active');
    setTimeout(function() { el.classList.add('active'); }, 300);   // Sicherheitsnetz
    // Arbeitsbereich wird zweispaltig, sobald es Produkte zu zeigen gibt —
    // vorher bleibt er zentriert, damit links keine leere Flaeche steht.
    var grid = document.getElementById('pbArbeitGrid');
    if (grid) grid.classList.add('hat-produkte');
    this.enrichProductCards(products);
    this.loadZubehoer();

    var allBtn = document.getElementById('pbAllCartBtn');
    if (allBtn) allBtn.addEventListener('click', function() { self.addAllToCart(); });
  };

  // ═══ PRODUCT ENRICHMENT ═══

  PB4.prototype.enrichProductCards = function(products) {
    var self = this;
    var area = this.state.summaryArea || 30;
    var promises = products.map(function(p) {
      if (p.handle) return self.enrichSingleProduct(p.handle, p.verbrauch, area);
      return Promise.resolve();
    });
    Promise.all(promises).then(function() {
      self.validateBadgesAfterEnrichment(products);
    });
  };

  PB4.prototype.enrichSingleProduct = function(handle, verbrauch, area) {
    var self = this;
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        self.state.enrichedProducts[handle] = product;

        var imgEl = document.querySelector('.pb-product-img[data-handle="' + handle + '"]');
        if (imgEl && product.featured_image) {
          var src = product.featured_image;
          if (src.indexOf('cdn.shopify.com') > -1) src = src.replace(/(\.[a-z]+)(\?|$)/, '_180x180$1$2');
          imgEl.innerHTML = '<img src="' + src + '" alt="' + escHtml(product.title || handle) + '" loading="lazy">';
        }

        var variants = product.variants || [];
        var purchaseEl = document.querySelector('.pb-product-purchase[data-handle="' + handle + '"]');
        if (!purchaseEl || !variants.length) return;

        var coats = 2;
        // +10 % Verschnitt — die FAQ verspricht den Sicherheitszuschlag, also wird er
        // hier auch tatsaechlich eingerechnet (GENERATION-RULES: +10 % mitkommunizieren).
        var litersNeeded = verbrauch ? parseFloat(verbrauch) * coats * area * 1.1 : 0;
        // Farb-Produkte: PC1-PC4 sind interne Preisklassen-Varianten — ohne
        // Farbton-Property sinnlos (ERP bekaeme "PC2" ohne Farbcode!) und fuer
        // Kunden unverstaendlich -> aus dem Select raus. "getönt" bleibt als
        // "Wunschfarbton"-Eintrag drin und oeffnet das Ton-Modal (Preis und
        // Machbarkeit haengen am konkreten Farbton).
        var istPC = function(v) { return /^PC[1-4]$/i.test(String(v.option1 || '')); };
        var istGetoent = function(v) { return /^get(\u00f6|oe)nt$/i.test(String(v.option1 || '')); };
        var basisVarianten = variants.filter(function(v) { return !istPC(v) && !istGetoent(v); });
        var recommended = self.findRecommendedVariant(basisVarianten.length ? basisVarianten : variants, litersNeeded);
        var verfuegbare = basisVarianten.filter(function(v) { return v.available; });
        // Nur verfuegbare Varianten anbieten: variants[0] als Fallback konnte
        // ausverkauft sein -> Shopify 422 -> generischer "Fehler"-Zustand.
        var selected = recommended || verfuegbare[0] || basisVarianten[0] || variants[0];
        var kaufbar = !!(selected && selected.available);
        var price = selected.price / 100;

        var selectHtml = '<select class="pb-gebinde-select" data-handle="' + handle + '">';
        variants.forEach(function(v) {
          if (!v.available || istPC(v)) return;
          var label = istGetoent(v)
            ? 'Wunschfarbton' + (v.option2 ? ' \u00b7 ' + escHtml(v.option2) : '') + ' \u2014 ab ' + formatPrice(v.price / 100)
            : escHtml(v.title) + ' \u2014 ' + formatPrice(v.price / 100);
          selectHtml += '<option value="' + v.id + '" data-price="' + v.price + '"' +
            (istGetoent(v) ? ' data-getoent="1"' : '') +
            (v.id === selected.id ? ' selected' : '') + '>' + label + '</option>';
        });
        selectHtml += '</select>';

        var kaufHtml = kaufbar
          ? '<button class="pb-atc-btn" data-handle="' + handle + '" data-variant-id="' + selected.id + '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            ' In den Warenkorb</button>'
          : '<a class="pb-atc-btn pb-atc-btn--info" href="/products/' + encodeURIComponent(handle) + '" target="_blank" rel="noopener">Zurzeit nicht lieferbar \u2192</a>';

        purchaseEl.innerHTML =
          '<div class="pb-product-calc"><div class="pb-product-price">' + formatPrice(price) + '</div>' +
          '<div class="pb-product-quantity">' +
          (litersNeeded > 0 ? 'Bedarf: ca. ' + litersNeeded.toFixed(1).replace('.', ',') + ' L für ' + area + ' m\u00B2 (inkl. 10\u202F% Verschnitt)' : escHtml(selected.title)) +
          '</div></div>' + selectHtml + kaufHtml;

        var sel = purchaseEl.querySelector('.pb-gebinde-select');
        if (sel) {
          sel.addEventListener('change', function() {
            var opt = sel.selectedOptions[0];
            var preisEl = purchaseEl.querySelector('.pb-product-price');
            var atc = purchaseEl.querySelector('.pb-atc-btn');
            var getoent = !!(opt && opt.getAttribute('data-getoent'));
            if (preisEl) preisEl.textContent = (getoent ? 'ab ' : '') + formatPrice(parseInt(opt.getAttribute('data-price')) / 100);
            if (atc) {
              atc.setAttribute('data-variant-id', sel.value);
              if (getoent) atc.setAttribute('data-getoent', '1');
              else atc.removeAttribute('data-getoent');
            }
            if (getoent) self.openTonModal(handle, parseInt(sel.value, 10));
          });
        }

        var atcBtn = purchaseEl.querySelector('.pb-atc-btn');
        if (atcBtn) {
          atcBtn.addEventListener('click', function() {
            if (atcBtn.getAttribute('data-getoent')) {
              self.openTonModal(handle, parseInt(atcBtn.getAttribute('data-variant-id'), 10));
              return;
            }
            self.addToCart(parseInt(atcBtn.getAttribute('data-variant-id')), 1, atcBtn);
          });
        }
      })
      .catch(function(err) {
        console.error('Enrich failed:', handle, err);
        // Produkt nicht (mehr) abrufbar (z.B. 24-h-Restore eines entfernten
        // Artikels): statt ewigem "Preis wird geladen..." einen Link anbieten.
        var purchaseEl = document.querySelector('.pb-product-purchase[data-handle="' + handle + '"]');
        if (purchaseEl) {
          purchaseEl.innerHTML = '<a class="pb-contact-btn" href="/products/' + encodeURIComponent(handle) + '" target="_blank" rel="noopener">Zum Produkt \u2192</a>';
        }
      });
  };

  PB4.prototype.findRecommendedVariant = function(variants, litersNeeded) {
    if (!litersNeeded || litersNeeded <= 0) return null;
    var re = /(\d+(?:[.,]\d+)?)\s*(?:l|liter|kg)/i;
    var best = null, bestDiff = Infinity;

    variants.forEach(function(v) {
      if (!v.available) return;
      var m = v.title.match(re);
      if (!m) return;
      var size = parseFloat(m[1].replace(',', '.'));
      var diff = size - litersNeeded;
      if (diff >= 0 && diff < bestDiff) { bestDiff = diff; best = v; }
    });

    if (!best) {
      var largest = null, largestSize = 0;
      variants.forEach(function(v) {
        if (!v.available) return;
        var m = v.title.match(re);
        if (!m) return;
        var size = parseFloat(m[1].replace(',', '.'));
        if (size > largestSize) { largestSize = size; largest = v; }
      });
      best = largest;
    }
    return best;
  };

  // ═══ TON-MODAL (getoent-Variante → Farbtonwahl) ═══
  // Wiederverwendet die Live-FTK-Bausteine statt sie zu duplizieren:
  //  - Suche: Worker /api/ftk/search — liefert {i:Code, n:Name, h:Hex, c:Karten-Slug}
  //  - Preisklasse: ftk-card-<c>.json colors[].tc (0=Weisston→PC1, 1-4=PC-Klasse)
  //  - Fertig-Weiss-Regel 2026-07-09 (exakt wie ftk-v18.js): nur AW11/AW15/
  //    RAL9010/RAL9016/NS01213 laufen ueber die weiss-Variante zum Weiss-Preis,
  //    alle anderen tc=0-Toene sind normale PC1-Toene.
  //  - Variante + Kauf: window.FTKATC (ftk-atc-v17.js) — resolveVariant/addToCart
  //  - Machbarkeit (MABA): window.FTK.isColorCompatibleWithProduct (Bridge) —
  //    Netzwerk-Fehler der Bridge = fail-open, identisch zur PDP (ftkMabaGate);
  //    die tc-Aufloesung selbst ist fail-closed: ohne Karte kein Kauf.
  // ERP-Properties exakt wie pdp-hero-v2: Farbe=CODE (nie der Name — Sto bekam
  // sonst "Anthrazit 4" statt "ALF0540"), Bez=Name, RGB="r,g,b", Modus.

  var FERTIG_WEISS_IDS = { AW11: 1, AW15: 1, RAL9010: 1, RAL9016: 1, NS01213: 1 };
  function tonKey(sVal) { return String(sVal || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase(); }
  function istFertigWeiss(id) { return FERTIG_WEISS_IDS[tonKey(id)] === 1; }
  function hexZuRgb(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return '';
    var n = parseInt(m[1], 16);
    return ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255);
  }

  PB4.prototype.setupTonModal = function() {
    var self = this;
    var modal = document.getElementById('pbTonModal');
    if (!modal) return;
    this.ton = { handle: null, variantId: null, sel: null, klasse: null, kaufVariantId: null,
                 karteCache: {}, sucheSeq: 0, assetsPromise: null };

    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-ton-schliessen]')) self.closeTonModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) self.closeTonModal();
    });

    var suche = document.getElementById('pbTonSuche');
    var debounce = null;
    suche.addEventListener('input', function() {
      clearTimeout(debounce);
      var q = suche.value.trim();
      debounce = setTimeout(function() { self.tonSuchen(q); }, 250);
    });

    document.getElementById('pbTonErgebnisse').addEventListener('click', function(e) {
      var btn = e.target.closest('.pb-ton-treffer');
      if (!btn) return;
      self.waehleTon({
        id: btn.getAttribute('data-id'), n: btn.getAttribute('data-n'),
        h: btn.getAttribute('data-h'), c: btn.getAttribute('data-c')
      }, btn);
    });

    document.getElementById('pbTonKaufen').addEventListener('click', function() { self.tonKaufen(); });
  };

  // Laedt ftk-atc-v17.js + Farbtonkonfigurator-Bridge lazy (nur wenn das Modal
  // wirklich gebraucht wird). URLs kommen aus data-Attributen der Section.
  PB4.prototype.ladeTonAssets = function() {
    var app = document.getElementById('projektberater-v4-app');
    if (!this.ton.assetsPromise) {
      var lade = function(src) {
        return new Promise(function(resolve) {
          var el = document.createElement('script');
          el.src = src; el.async = true;
          el.onload = resolve; el.onerror = resolve; // fail-open: Zustaende werden unten geprueft
          document.head.appendChild(el);
        });
      };
      var jobs = [];
      if (!window.FTKATC && app.getAttribute('data-ftk-atc-url')) jobs.push(lade(app.getAttribute('data-ftk-atc-url')));
      if (!(window.FTK && window.FTK.isColorCompatibleWithProduct) && app.getAttribute('data-ftk-bridge-url')) {
        window.FTK_ASSET_BASE = window.FTK_ASSET_BASE || app.getAttribute('data-ftk-asset-base');
        jobs.push(lade(app.getAttribute('data-ftk-bridge-url')));
      }
      this.ton.assetsPromise = Promise.all(jobs);
    }
    return this.ton.assetsPromise;
  };

  PB4.prototype.openTonModal = function(handle, getoentVariantId) {
    var self = this;
    var modal = document.getElementById('pbTonModal');
    var product = this.state.enrichedProducts[handle];
    if (!modal || !product) return;
    var variante = (product.variants || []).find(function(v) { return v.id === getoentVariantId; });
    if (!variante) return;

    this.ton.handle = handle;
    this.ton.variantId = getoentVariantId;
    this.ton.sel = null; this.ton.klasse = null; this.ton.kaufVariantId = null;

    document.getElementById('pbTonProdukt').textContent =
      product.title + (variante.option2 ? ' · ' + variante.option2 : '') + ' — der Preis richtet sich nach dem Farbton';
    var pdpLink = document.getElementById('pbTonPdpLink');
    pdpLink.href = '/products/' + encodeURIComponent(handle);
    pdpLink.hidden = true;
    document.getElementById('pbTonAuswahl').hidden = true;
    var erg = document.getElementById('pbTonErgebnisse');
    erg.innerHTML = '<p class="pb-ton-leer">Tipp deinen Wunschton oben ein — wir durchsuchen alle Sto-Farbtonkarten.</p>';
    var suche = document.getElementById('pbTonSuche');
    suche.value = '';

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.ladeTonAssets();
    setTimeout(function() { suche.focus(); }, 50);
    this.trackEvent('pb_ton_modal_open', { product_handle: handle });
  };

  PB4.prototype.closeTonModal = function() {
    var modal = document.getElementById('pbTonModal');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
  };

  PB4.prototype.tonSuchen = function(q) {
    var self = this;
    var erg = document.getElementById('pbTonErgebnisse');
    var app = document.getElementById('projektberater-v4-app');
    var endpoint = app.getAttribute('data-ftk-search-endpoint');
    if (!q || q.length < 2) {
      erg.innerHTML = '<p class="pb-ton-leer">Tipp deinen Wunschton oben ein — wir durchsuchen alle Sto-Farbtonkarten.</p>';
      return;
    }
    var seq = ++this.ton.sucheSeq;
    fetch(endpoint + '?q=' + encodeURIComponent(q) + '&limit=24')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (seq !== self.ton.sucheSeq) return; // veraltete Antwort verwerfen
        var treffer = (data && data.results) || [];
        if (!treffer.length) {
          erg.innerHTML = '<p class="pb-ton-leer">Nichts gefunden für „' + escHtml(q) + '“. Probier die Farbton-Nummer (z. B. 33101) oder den RAL-Code.</p>';
          return;
        }
        erg.innerHTML = treffer.map(function(t) {
          return '<button type="button" class="pb-ton-treffer" role="option"' +
            ' data-id="' + escHtml(t.i) + '" data-n="' + escHtml(t.n) + '" data-h="' + escHtml(t.h) + '" data-c="' + escHtml(t.c) + '">' +
            '<span class="pb-ton-swatch" style="background:' + escHtml(t.h) + '"></span>' +
            '<span class="pb-ton-treffer-text"><strong>' + escHtml(t.n) + '</strong><span>' + escHtml(t.i) + '</span></span>' +
            '</button>';
        }).join('');
      })
      .catch(function() {
        if (seq !== self.ton.sucheSeq) return;
        erg.innerHTML = '<p class="pb-ton-leer">Die Farbton-Suche ist gerade nicht erreichbar. ' +
          '<a class="pb-ton-pdp-link" href="/products/' + encodeURIComponent(self.ton.handle || '') + '" target="_blank" rel="noopener">Ton auf der Produktseite wählen &rarr;</a></p>';
      });
  };

  PB4.prototype.ladeTonKarte = function(slug) {
    var self = this;
    if (this.ton.karteCache[slug]) return this.ton.karteCache[slug];
    var app = document.getElementById('projektberater-v4-app');
    var base = app.getAttribute('data-ftk-asset-base') || '/';
    this.ton.karteCache[slug] = fetch(base + 'ftk-card-' + slug + '.json')
      .then(function(r) { if (!r.ok) throw new Error('Karte ' + r.status); return r.json(); })
      .catch(function(err) { delete self.ton.karteCache[slug]; throw err; });
    return this.ton.karteCache[slug];
  };

  PB4.prototype.tonHinweis = function(text, warnung) {
    var el = document.getElementById('pbTonHinweis');
    el.hidden = !text;
    el.textContent = text || '';
    el.classList.toggle('pb-ton-hinweis--warnung', !!warnung);
  };

  PB4.prototype.waehleTon = function(ton, btnEl) {
    var self = this;
    var product = this.state.enrichedProducts[this.ton.handle];
    if (!product) return;
    var getoentV = (product.variants || []).find(function(v) { return v.id === self.ton.variantId; });
    if (!getoentV) return;

    this.ton.sel = ton;
    this.ton.klasse = null; this.ton.kaufVariantId = null;

    var erg = document.getElementById('pbTonErgebnisse');
    Array.prototype.forEach.call(erg.querySelectorAll('.pb-ton-treffer'), function(b) {
      b.classList.toggle('aktiv', b === btnEl);
    });

    document.getElementById('pbTonSwatch').style.background = ton.h || '#fff';
    document.getElementById('pbTonName').textContent = ton.n || ton.id;
    document.getElementById('pbTonMeta').textContent = 'Farbton-Nr. ' + ton.id;
    document.getElementById('pbTonPreis').textContent = '…';
    document.getElementById('pbTonAuswahl').hidden = false;
    var kaufBtn = document.getElementById('pbTonKaufen');
    kaufBtn.hidden = false; kaufBtn.disabled = true;
    document.getElementById('pbTonPdpLink').hidden = true;
    this.tonHinweis('');
    this.trackEvent('pb_ton_selected', { product_handle: this.ton.handle, color_id: ton.id });

    var meinTon = ton; // gegen Race: nur reagieren, wenn der Ton noch gewaehlt ist
    var abbruch = function(text) {
      if (self.ton.sel !== meinTon) return;
      document.getElementById('pbTonPreis').textContent = '';
      kaufBtn.disabled = true; kaufBtn.hidden = true;
      document.getElementById('pbTonPdpLink').hidden = false;
      self.tonHinweis(text, true);
      self.trackEvent('pb_ton_blocked', { product_handle: self.ton.handle, color_id: meinTon.id });
    };

    Promise.all([this.ladeTonAssets(), this.ladeTonKarte(ton.c)])
      .then(function(res) {
        if (self.ton.sel !== meinTon) return;
        var karte = res[1];
        var eintrag = (karte.colors || []).find(function(x) { return x.id === meinTon.id; });
        // tc-Aufloesung ist fail-closed: ohne Karteneintrag keine Preisklasse -> kein Kauf
        if (!eintrag) { abbruch('Diesen Farbton können wir hier nicht direkt bestellen. Nutz dafür bitte die Produktseite — oder frag unsere kostenlose Video-Beratung.'); return; }

        var fertigWeiss = istFertigWeiss(meinTon.id);
        var tc = eintrag.tc;
        var klasse = null;
        if (fertigWeiss) klasse = 'weiss';
        else if (tc === 0 || tc === '0') klasse = '1';
        else if (tc >= 1 && tc <= 4) klasse = String(tc);
        if (!klasse) { abbruch('Für diesen Farbton können wir den Preis hier nicht sicher bestimmen. Wähl ihn bitte auf der Produktseite — dort läuft die volle Prüfung.'); return; }

        // Variante aufloesen
        var kaufV = null;
        if (klasse === 'weiss') {
          var o2 = getoentV.option2 || null, o3 = getoentV.option3 || null;
          var weisse = (product.variants || []).filter(function(v) {
            return /^wei(ß|ss)$/i.test(String(v.option1 || ''));
          });
          kaufV = weisse.find(function(v) { return v.option2 === o2 && v.option3 === o3; }) ||
                  weisse.find(function(v) { return v.option2 === o2; }) || weisse[0] || null;
        } else if (window.FTKATC && window.FTKATC.resolveVariant) {
          var res2 = window.FTKATC.resolveVariant({
            variants: product.variants, klasse: klasse,
            currentO2: getoentV.option2 || null, currentO3: getoentV.option3 || null
          });
          if (res2) kaufV = (product.variants || []).find(function(v) { return v.id === res2.variantId; }) || null;
        }
        if (!kaufV) { abbruch('Diese Kombination können wir hier nicht bestellen — bitte auf der Produktseite wählen.'); return; }
        if (!kaufV.available) { abbruch('Dieses Gebinde ist im gewünschten Farbton gerade nicht lieferbar. Auf der Produktseite siehst du die verfügbaren Größen.'); return; }

        self.ton.klasse = klasse;
        self.ton.kaufVariantId = kaufV.id;
        document.getElementById('pbTonPreis').textContent = formatPrice(kaufV.price / 100);
        kaufBtn.disabled = false;
        if (fertigWeiss) self.tonHinweis('Fertig-Weißton — kommt ohne Tönzuschlag zum Weiß-Preis.');
        else self.tonHinweis('Preis inkl. Tönservice (Preisklasse PC' + klasse + '). Wir tönen jeden Eimer frisch für dich.');

        // Machbarkeit (MABA): Sperrliste Ton x Produkt. Fail-open bei Bridge-
        // Fehlern — exakt wie ftkMabaGate auf der PDP.
        var sku = String(getoentV.sku || (product.variants[0] || {}).sku || '').replace(/\/[1-4]$/, '');
        if (sku && window.FTK && window.FTK.isColorCompatibleWithProduct) {
          var mabaLauf = window.FTK.triggerMabaLoad ? window.FTK.triggerMabaLoad() : null;
          Promise.resolve(mabaLauf).catch(function() {}).then(function() {
            if (self.ton.sel !== meinTon) return;
            var kompatibel = true;
            try { kompatibel = window.FTK.isColorCompatibleWithProduct(meinTon.id, sku); } catch (e) {}
            if (kompatibel === false) {
              abbruch('Diesen Farbton können wir in diesem Produkt leider nicht antönen (Sto-Machbarkeit). Wähl einen ähnlichen Ton — oder frag unsere kostenlose Video-Beratung.');
            }
          });
        }
      })
      .catch(function() {
        abbruch('Die Farbton-Daten sind gerade nicht erreichbar. Wähl den Ton bitte auf der Produktseite.');
      });
  };

  PB4.prototype.tonKaufen = function() {
    var self = this;
    var ton = this.ton.sel;
    var kaufBtn = document.getElementById('pbTonKaufen');
    if (!ton || !this.ton.kaufVariantId || !window.FTKATC || !window.FTKATC.addToCart) return;
    var vorher = kaufBtn.innerHTML;
    kaufBtn.disabled = true;
    kaufBtn.textContent = 'Wird hinzugefügt …';
    // ERP-Properties exakt wie pdp-hero-v2: "Farbe" = Farbton-CODE (id), nie der
    // Name — sonst bekommt Sto "Anthrazit 4" statt "ALF0540" (Bug seit V18).
    window.FTKATC.addToCart({
      variantId: this.ton.kaufVariantId,
      qty: 1,
      properties: { Farbe: ton.id, Bez: ton.n || ton.id, RGB: hexZuRgb(ton.h), Modus: 'projektberater' },
      triggerBtn: kaufBtn
    }).then(function(res) {
      kaufBtn.innerHTML = vorher;
      kaufBtn.disabled = false;
      if (res && res.ok) {
        self.trackEvent('pb_ton_added_to_cart', {
          product_handle: self.ton.handle, color_id: ton.id, klasse: self.ton.klasse
        });
        self.closeTonModal();
      } else {
        self.tonHinweis((res && res.error) || 'Das hat leider nicht geklappt — bitte versuch es erneut.', true);
        self.trackEvent('pb_cart_fehler', { variant_id: self.ton.kaufVariantId, quelle: 'ton_modal' });
      }
    });
  };

  // ═══ POST-ENRICHMENT BADGE VALIDATION ═══

  PB4.prototype.validateBadgesAfterEnrichment = function(products) {
    if (!products || products.length < 2) return;

    var self = this;
    var priceData = [];

    products.forEach(function(p) {
      var enriched = self.state.enrichedProducts[p.handle];
      if (!enriched || !enriched.variants || !enriched.variants.length) return;

      // Calculate price per liter from smallest available variant
      var minPricePerL = Infinity;
      var re = /(\d+(?:[.,]\d+)?)\s*(?:l|liter|kg)/i;
      enriched.variants.forEach(function(v) {
        if (!v.available) return;
        var m = v.title.match(re);
        if (!m) return;
        var size = parseFloat(m[1].replace(',', '.'));
        if (size > 0) {
          var ppl = v.price / size;
          if (ppl < minPricePerL) minPricePerL = ppl;
        }
      });

      if (minPricePerL < Infinity) {
        priceData.push({ handle: p.handle, tier: p.tier, pricePerL: minPricePerL });
      }
    });

    if (priceData.length < 2) return;

    var top = priceData.find(function(d) { return d.tier === 'top'; });
    var alt = priceData.find(function(d) { return d.tier === 'alt'; });
    var prem = priceData.find(function(d) { return d.tier === 'prem'; });

    if (!top) return;

    var tolerance = 0.10; // 10% tolerance
    var needsSwap = false;

    // alt should be cheaper or equal to top (with tolerance)
    if (alt && alt.pricePerL > top.pricePerL * (1 + tolerance)) {
      console.warn('Badge swap: alt (' + alt.handle + ' ' + Math.round(alt.pricePerL) + '/L) is more expensive than top (' + top.handle + ' ' + Math.round(top.pricePerL) + '/L)');
      needsSwap = true;
      self.swapBadgesInDOM(alt.handle, 'top', top.handle, 'alt');
    }

    // prem should be more expensive or equal to top (with tolerance)
    if (prem && prem.pricePerL < top.pricePerL * (1 - tolerance)) {
      console.warn('Badge swap: prem (' + prem.handle + ' ' + Math.round(prem.pricePerL) + '/L) is cheaper than top (' + top.handle + ' ' + Math.round(top.pricePerL) + '/L)');
      needsSwap = true;
      // After potential first swap, re-check what's currently "top"
      var currentTopHandle = alt && alt.pricePerL > top.pricePerL * (1 + tolerance) ? alt.handle : top.handle;
      self.swapBadgesInDOM(prem.handle, 'top', currentTopHandle, 'prem');
    }
  };

  PB4.prototype.swapBadgesInDOM = function(handle1, newTier1, handle2, newTier2) {
    var badgeLabelMap = { top: 'Top-Empfehlung', alt: 'Preis-Alternative', prem: 'Premium-Upgrade' };

    var card1 = document.querySelector('.pb-product-card[data-handle="' + handle1 + '"]');
    var card2 = document.querySelector('.pb-product-card[data-handle="' + handle2 + '"]');
    if (!card1 || !card2) return;

    var badge1 = card1.querySelector('.pb-badge');
    var badge2 = card2.querySelector('.pb-badge');
    if (!badge1 || !badge2) return;

    // Update badge classes and labels
    badge1.className = 'pb-badge pb-badge--' + newTier1;
    badge1.textContent = badgeLabelMap[newTier1] || 'Empfehlung';
    badge2.className = 'pb-badge pb-badge--' + newTier2;
    badge2.textContent = badgeLabelMap[newTier2] || 'Empfehlung';

    // Update top card styling
    card1.classList.toggle('pb-product-card--top', newTier1 === 'top');
    card2.classList.toggle('pb-product-card--top', newTier2 === 'top');
  };

  // ═══ ZUBEHOER ═══

  PB4.prototype.loadZubehoer = function() {
    var self = this;
    var handles = (ZUBEHOER_MAP[this.state.apiCategory] || ZUBEHOER_MAP['auto']).slice();

    // Dynamische Grundierung aus AI-Ergebnis anhängen
    var grundierung = this.state.resultData && this.state.resultData.grundierung;
    var grundierungHandle = grundierung && grundierung.handle;
    if (grundierungHandle && handles.indexOf(grundierungHandle) === -1) {
      handles.push(grundierungHandle);
    }

    var promises = handles.map(function(h) {
      return fetch('/products/' + h + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var isGrund = (h === grundierungHandle);
          var variants = (p.variants || []).map(function(v) {
            return { id: v.id, title: v.title, price: v.price / 100, available: v.available };
          });
          var firstV = variants[0] || {};
          return {
            handle: h, title: p.title, price: firstV.price || 0, image: p.featured_image,
            variantId: firstV.id || null, available: p.available,
            variants: variants,
            beschreibung: isGrund ? (grundierung.kurztext || 'Optimale Haftung für deinen Untergrund') : (ZUBEHOER_BESCHREIBUNG[h] || ''),
            reichweite: ZUBEHOER_REICHWEITE[h] || null,
            isGrundierung: isGrund, checked: true, qty: 1
          };
        })
        .catch(function() { return null; });
    });
    Promise.all(promises).then(function(items) {
      self.renderZubehoer(items.filter(function(i) { return i !== null; }));
    });
  };

  PB4.prototype.renderZubehoer = function(items) {
    var self = this;
    var container = document.getElementById('pbZubehoerItems');
    if (!container || !items.length) return;

    var html = '';
    items.forEach(function(item, idx) {
      var src = item.image || '';
      if (src && src.indexOf('cdn.shopify.com') > -1) src = src.replace(/(\.[a-z]+)(\?|$)/, '_80x80$1$2');
      var hasMultiVariants = item.variants && item.variants.length > 1;

      html += '<div class="pb-zubehoer-item' + (item.isGrundierung ? ' pb-zubehoer-item--grundierung' : '') + '" data-idx="' + idx + '">' +
        '<label class="pb-zubehoer-check">' +
        '<input type="checkbox" checked data-idx="' + idx + '">' +
        '<span class="pb-zubehoer-checkmark"></span></label>' +
        '<div class="pb-zubehoer-icon">' +
        (src ? '<img src="' + src + '" alt="' + escHtml(item.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="pb-zubehoer-details">' +
        '<div class="pb-zubehoer-name">' + escHtml(item.title) + '</div>' +
        (item.beschreibung ? '<div class="pb-zubehoer-desc">' + escHtml(item.beschreibung) + '</div>' : '');

      // Varianten-Dropdown wenn >1 Variante
      if (hasMultiVariants) {
        html += '<select class="pb-zubehoer-variant-select" data-idx="' + idx + '">';
        item.variants.forEach(function(v) {
          html += '<option value="' + v.id + '" data-price="' + v.price + '"' + (v.id === item.variantId ? ' selected' : '') + '>' +
            escHtml(v.title) + ' \u2014 ' + formatPrice(v.price) + '</option>';
        });
        html += '</select>';
      }

      // Reichweite-Info
      if (item.reichweite) {
        html += '<div class="pb-zubehoer-reichweite">\u2197 Reicht f\u00fcr ' + escHtml(item.reichweite) + '</div>';
      }

      html += '</div>' + // close details
        '<div class="pb-zubehoer-right">' +
        '<div class="pb-zubehoer-price" data-idx="' + idx + '">' + formatPrice(item.price) + '</div>' +
        '<div class="pb-zubehoer-qty">' +
        '<button type="button" class="pb-qty-btn pb-qty-minus" data-idx="' + idx + '">\u2212</button>' +
        '<span class="pb-qty-value" data-idx="' + idx + '">1</span>' +
        '<button type="button" class="pb-qty-btn pb-qty-plus" data-idx="' + idx + '">+</button>' +
        '</div></div></div>';
    });

    var total = items.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
    html += '<button class="pb-zubehoer-atc" id="pbZubehoerAtc">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
      ' Zubehör hinzufügen \u2014 <span id="pbZubehoerTotal">' + formatPrice(total) + '</span></button>';

    container.innerHTML = html;
    self.state.zubehoerItems = items;

    // Checkbox Events
    container.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var idx = parseInt(this.getAttribute('data-idx'));
        self.state.zubehoerItems[idx].checked = this.checked;
        this.closest('.pb-zubehoer-item').classList.toggle('pb-zubehoer-unchecked', !this.checked);
        self.updateZubehoerTotal();
      });
    });

    // Varianten-Select Events
    container.querySelectorAll('.pb-zubehoer-variant-select').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var idx = parseInt(this.getAttribute('data-idx'));
        var item = self.state.zubehoerItems[idx];
        var opt = this.options[this.selectedIndex];
        item.variantId = parseInt(this.value);
        item.price = parseFloat(opt.getAttribute('data-price'));
        container.querySelector('.pb-zubehoer-price[data-idx="' + idx + '"]').textContent = formatPrice(item.price);
        self.updateZubehoerTotal();
      });
    });

    // Mengen-Stepper Events
    container.querySelectorAll('.pb-qty-minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-idx'));
        var item = self.state.zubehoerItems[idx];
        if (item.qty > 1) { item.qty--; container.querySelector('.pb-qty-value[data-idx="' + idx + '"]').textContent = item.qty; self.updateZubehoerTotal(); }
      });
    });
    container.querySelectorAll('.pb-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-idx'));
        var item = self.state.zubehoerItems[idx];
        if (item.qty < 10) { item.qty++; container.querySelector('.pb-qty-value[data-idx="' + idx + '"]').textContent = item.qty; self.updateZubehoerTotal(); }
      });
    });

    var zBtn = document.getElementById('pbZubehoerAtc');
    if (zBtn) zBtn.addEventListener('click', function() { self.addZubehoerToCart(zBtn); });
  };

  PB4.prototype.updateZubehoerTotal = function() {
    var total = 0;
    (this.state.zubehoerItems || []).forEach(function(item) {
      if (item.checked) total += item.price * item.qty;
    });
    var el = document.getElementById('pbZubehoerTotal');
    if (el) el.textContent = formatPrice(total);
  };

  // ═══ CART ═══

  PB4.prototype.addToCart = function(variantId, quantity, btn) {
    var self = this;
    // Fallback-Zustand: Button wurde bereits zu "Zum Warenkorb" umgewidmet —
    // der alte Listener darf dann nicht erneut in den Warenkorb legen.
    if (btn && btn.dataset && btn.dataset.fbGotoCart) { window.location.href = '/cart'; return; }
    if (!variantId) return;
    var orig = btn.innerHTML;
    btn.innerHTML = 'Wird hinzugefügt...'; btn.disabled = true;

    // 20-s-Timeout: ohne ihn blieb der Button bei haengender Verbindung dauerhaft
    // auf "Wird hinzugefuegt…".
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var zeitmesser = ctrl ? setTimeout(function() { ctrl.abort(); }, 20000) : null;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }], sections: 'cart-drawer,cart-icon-bubble' })
    })
    .then(function(r) {
      if (zeitmesser) clearTimeout(zeitmesser);
      if (!r.ok) {
        // Shopify liefert bei 422 den echten Grund mit (z.B. Bestand erschoepft)
        return r.json().catch(function() { return {}; }).then(function(f) {
          var e = new Error(f.description || f.message || 'Cart error');
          e.fachlich = !!(f.description || f.message);
          throw e;
        });
      }
      return r.json();
    })
    .then(function(data) {
      btn.innerHTML = '\u2713 Hinzugefügt!'; btn.style.background = 'var(--success)'; btn.style.color = '#fff';
      self.updateCartBadge();
      self.trackEvent('pb_product_added_to_cart', { variant_id: variantId });
      self.setCartAttribute();
      var opened = self.openCartDrawer(data);
      setTimeout(function() {
        btn.style.background = ''; btn.style.color = ''; btn.disabled = false;
        if (opened) { btn.innerHTML = orig; }
        else {
          // Kein Drawer im Theme aktiv -> Button dauerhaft als Weg zur Kasse.
          // Kein onclick-Stacking: das Flag laesst addToCart nur noch navigieren.
          btn.innerHTML = 'Zum Warenkorb \u2192';
          btn.dataset.fbGotoCart = '1';
        }
      }, 1200);
    })
    .catch(function(err) {
      if (zeitmesser) clearTimeout(zeitmesser);
      var text = (err && err.fachlich) ? escHtml(String(err.message)).slice(0, 70)
               : (err && err.name === 'AbortError') ? 'Zeitüberschreitung \u2014 nochmal?'
               : 'Hat nicht geklappt \u2014 nochmal?';
      btn.innerHTML = text; btn.disabled = false;
      self.trackEvent('pb_cart_fehler', { grund: (err && err.message ? String(err.message) : 'unbekannt').slice(0, 60) });
      setTimeout(function() { btn.innerHTML = orig; }, 4000);
    });
  };

  PB4.prototype.addZubehoerToCart = function(btn) {
    var self = this;
    var items = (this.state.zubehoerItems || [])
      .filter(function(i) { return i.checked && i.variantId && i.available; })
      .map(function(i) { return { id: i.variantId, quantity: i.qty || 1 }; });
    if (!items.length) return;
    var orig = btn.innerHTML;
    btn.innerHTML = 'Wird hinzugefügt...'; btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
    })
    .then(function(r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
    .then(function(data) {
      btn.innerHTML = '\u2713 Zubehör hinzugefügt!'; btn.style.background = 'var(--success)'; btn.style.color = '#fff';
      self.updateCartBadge(); self.trackEvent('pb_zubehoer_added_to_cart');
      self.setCartAttribute();
      self.openCartDrawer(data);
      setTimeout(function() { btn.innerHTML = orig; btn.style.background = ''; btn.style.color = ''; btn.disabled = false; }, 1200);
    })
    .catch(function() { btn.innerHTML = 'Fehler'; btn.disabled = false; setTimeout(function() { btn.innerHTML = orig; }, 2000); });
  };

  PB4.prototype.addAllToCart = function() {
    var self = this;
    var allBtn = document.getElementById('pbAllCartBtn');
    if (!allBtn) return;
    var items = [];
    document.querySelectorAll('.pb-atc-btn[data-variant-id]').forEach(function(b) {
      var vid = parseInt(b.getAttribute('data-variant-id'));
      if (vid) items.push({ id: vid, quantity: 1 });
    });
    (this.state.zubehoerItems || []).forEach(function(i) {
      if (i.checked && i.variantId && i.available) items.push({ id: i.variantId, quantity: i.qty || 1 });
    });
    if (!items.length) return;
    var orig = allBtn.innerHTML;
    allBtn.innerHTML = 'Wird hinzugefügt...'; allBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
    })
    .then(function(r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
    .then(function(data) {
      allBtn.innerHTML = '\u2713 Alles hinzugefügt!'; allBtn.style.background = 'var(--success)'; allBtn.style.color = '#fff';
      self.updateCartBadge(); self.trackEvent('pb_all_added_to_cart', { items_count: items.length });
      self.setCartAttribute();
      self.openCartDrawer(data);
      setTimeout(function() { allBtn.innerHTML = orig; allBtn.style.background = ''; allBtn.style.color = ''; allBtn.disabled = false; }, 1200);
    })
    .catch(function() { allBtn.innerHTML = 'Fehler'; allBtn.disabled = false; setTimeout(function() { allBtn.innerHTML = orig; }, 2000); });
  };

  // Nach ATC den nativen Dawn-Cart-Drawer aktualisieren UND oeffnen — vorher endete
  // die Kaufkette im Nichts (Button-Reset nach 2 s, kein Weg zur Kasse). Muster
  // identisch zum Upsell in snippets/cart-drawer.liquid.
  PB4.prototype.openCartDrawer = function(data) {
    try {
      if (data && data.sections) {
        Object.keys(data.sections).forEach(function(sid) {
          var doc = new DOMParser().parseFromString(data.sections[sid], 'text/html');
          if (sid === 'cart-drawer') {
            var drawer = document.querySelector('cart-drawer');
            var newDrawer = doc.querySelector('cart-drawer');
            if (drawer && newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          } else if (sid === 'cart-icon-bubble') {
            var bubble = document.getElementById('cart-icon-bubble');
            var newBubble = doc.getElementById('shopify-section-cart-icon-bubble');
            if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        });
      }
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.open === 'function') {
        drawerEl.classList.remove('is-empty');
        // Der Overlay-Close-Listener hing am ersetzten alten DOM-Knoten —
        // ohne Re-Bind schloss ein Klick auf den Hintergrund nicht mehr
        // (Dawns renderContents macht exakt dasselbe).
        var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawerEl.close === 'function') {
          overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
        }
        drawerEl.open();
        return true;
      }
    } catch (e) { /* Drawer nicht verfuegbar -> Fallback unten */ }
    return false;
  };

  PB4.prototype.updateCartBadge = function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .header__cart-count').forEach(function(b) {
        b.textContent = cart.item_count;
        if (b.classList.contains('hidden')) b.classList.remove('hidden');
      });
    }).catch(function() {});
  };

  // ═══ CHAT ═══

  PB4.prototype.restChips = function() {
    var self = this;
    return this.startChips(this.state.resultData).filter(function(f) {
      return self.state.gestellteFragen.indexOf(f) === -1;
    });
  };

  PB4.prototype.handleChatSend = function(vorgabe) {
    var self = this;
    var input = document.getElementById('pbChatInput');
    var msgs = document.getElementById('pbChatMessages');
    if (!input || !msgs) return;
    var text = (vorgabe || input.value).trim();
    if (!text) return;

    var userDiv = document.createElement('div');
    userDiv.className = 'pb-chat-msg pb-chat-msg--user';
    userDiv.textContent = text;
    msgs.appendChild(userDiv);
    input.value = '';
    msgs.scrollTop = msgs.scrollHeight;

    this.state.dialogHistory.push({ role: 'user', content: text });

    var chipBox = document.getElementById('pbChatChips');
    if (chipBox) chipBox.hidden = true;

    var typingDiv = document.createElement('div');
    typingDiv.className = 'pb-chat-msg pb-chat-msg--bot';
    typingDiv.innerHTML = '<div class="pb-typing-dots"><span></span><span></span><span></span></div>' +
      '<span class="pb-chat-wartezeit" aria-live="off"></span>';
    msgs.appendChild(typingDiv);
    msgs.scrollTop = msgs.scrollHeight;

    // Sichtbare Wartezeit: laufender Sekundenzaehler statt stummer Punkte —
    // symbolisiert, dass KI-Thomas wirklich arbeitet (Andres Wunsch 19.08.).
    var warteStart = Date.now();
    var warteEl = typingDiv.querySelector('.pb-chat-wartezeit');
    var warteIv = setInterval(function() {
      if (!warteEl || !typingDiv.isConnected) { clearInterval(warteIv); return; }
      var sek = Math.round((Date.now() - warteStart) / 1000);
      if (sek >= 2) {
        warteEl.textContent = 'KI-Thomas denkt nach \u00b7 ' + sek + '\u202fs' +
          (sek >= 15 ? ' \u2014 gleich fertig \u2026' : '');
      }
    }, 1000);

    self.trackEvent('pb_chat_message_sent');

    // 45-s-Timeout: Ohne ihn drehten die Punkte bei haengendem Worker endlos.
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = ctrl ? setTimeout(function() { ctrl.abort(); }, 45000) : null;

    fetch(this.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ category: this.state.apiCategory || 'auto', dialog_history: this.state.dialogHistory, quick_mode: false, session_id: this.state.sessionId, answers: this.state.treeAnswers || [], mode: 'ai' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (timeoutId) clearTimeout(timeoutId);
      // KI-Text wird escaped (XSS); der Eskalations-Fallback ist eigener, statischer
      // HTML-String und darf seine Links behalten.
      var respHtml = '';
      var respText = '';
      var folgeChips = null;
      var chipTyp = 'frage';
      if (data.type === 'question' && data.question) {
        respText = data.question.text || data.question;
        respHtml = formatAIText(escHtml(respText));
        // Stellt KI-Thomas eine Gegenfrage, sind die Chips seine eigenen
        // Antwortoptionen — sie passen damit immer exakt zur Frage.
        if (data.question.options && data.question.options.length) {
          folgeChips = data.question.options;
          chipTyp = 'antwort';
        }
      } else if (data.type === 'result' && data.result) {
        respText = data.result.malermeister_tipp || 'Hier ist meine aktualisierte Empfehlung.';
        respHtml = formatAIText(escHtml(respText));
      } else {
        respText = 'Da bin ich mir nicht sicher \u2014 ruf unser Team gerne an unter 05042 98 49 001 oder buch eine kostenlose Video-Beratung.';
        respHtml = 'Da bin ich mir nicht sicher \u2014 ruf unser Team gerne an unter <strong>05042 98 49 001</strong> oder <a href="/pages/videoberatung" data-beratung-cta data-beratung-quelle="projektberater_chat">buch eine kostenlose Video-Beratung</a>.';
      }
      clearInterval(warteIv);
      self.state.dialogHistory.push({ role: 'assistant', content: respText });
      typingDiv.innerHTML = '<strong>KI-Thomas:</strong> ' + respHtml;
      msgs.scrollTop = msgs.scrollHeight;
      // Antwortoptionen der Gegenfrage, sonst die noch offenen Anschlussfragen
      self.renderChatChips(folgeChips || self.restChips(), chipTyp);
    })
    .catch(function() {
      if (timeoutId) clearTimeout(timeoutId);
      clearInterval(warteIv);
      self.renderChatChips(self.restChips(), 'frage');
      typingDiv.innerHTML = '<strong>KI-Thomas:</strong> Entschuldigung, da ist leider etwas schiefgegangen. Ruf unser Team gerne an unter <strong>05042 98 49 001</strong> oder <a href="/pages/videoberatung" data-beratung-cta data-beratung-quelle="projektberater_chat_fehler">buch eine kostenlose Video-Beratung</a>.';
      msgs.scrollTop = msgs.scrollHeight;
    });
  };

  // ═══ ERROR ═══

  PB4.prototype.showError = function(message) {
    var self = this;
    this.state.loadingActive = false;
    this.trackEvent('pb_error_shown');
    var old = document.getElementById('screenError');
    if (old) old.remove();
    var screen = document.createElement('div');
    screen.className = 'pb-screen pb-screen-dynamic';
    screen.id = 'screenError';
    screen.innerHTML = '<div class="pb-loading-center">' +
      '<div style="font-size:48px;margin-bottom:16px;">\u26A0\uFE0F</div>' +
      '<div class="pb-loading-title">' + escHtml(message) + '</div>' +
      '<button class="pb-cta" id="pbRetryBtn" style="margin-top:24px;">Erneut versuchen</button>' +
      '<div class="pb-error-alt">Oder lass dich direkt von Menschen beraten:<br>' +
      '<a href="/pages/videoberatung" data-beratung-cta data-beratung-quelle="projektberater_fehler">Kostenlose Video-Beratung</a>' +
      ' \u00B7 <a href="tel:+4950429849001">05042 98 49 001</a></div></div>';
    document.getElementById('pbWizardBody').appendChild(screen);
    screen.querySelector('#pbRetryBtn').addEventListener('click', function() {
      // Letzten Request wiederholen statt die komplette Sitzung zu verwerfen —
      // vorher loeschte "Erneut versuchen" alle Angaben des Nutzers.
      if (self.state.dialogHistory && self.state.dialogHistory.length) {
        self.showLoadingScreen(!!self.state.lastSkipDiscovery);
        self.sendToWorker(!!self.state.lastSkipDiscovery);
      } else {
        self.restart();
      }
    });
    this.goTo('screenError');
  };

  // ═══ ANALYTICS ═══

  // gtag statt dataLayer: Das Theme laedt GA4 direkt ueber gtag(), ein GTM existiert
  // nicht — die frueheren dataLayer.push-Events kamen deshalb nie in GA4 an
  // (28 Tage, 1.700 Sessions, 0 Events). dataLayer bleibt als Fallback bestehen.
  // gtag kommt aus einem App-Embed und ist beim defer-Start dieses Skripts oft
  // noch nicht da. Frueher fielen genau die schnellsten Nutzer (Kategorie-Klick
  // in der ersten Sekunde) in den toten dataLayer-Zweig. Jetzt wird gepuffert.
  var _evQueue = [];
  var _queueLaeuft = false;

  function _queueAbarbeiten() {
    if (typeof window.gtag !== 'function') return false;
    while (_evQueue.length) {
      var e = _evQueue.shift();
      window.gtag('event', e.name, e.params);
    }
    return true;
  }

  PB4.prototype.trackEvent = function(event, params) {
    var d = params || {};
    if (typeof window.gtag === 'function') {
      _queueAbarbeiten();
      window.gtag('event', event, d);
      return;
    }
    _evQueue.push({ name: event, params: d });
    if (_queueLaeuft) return;
    _queueLaeuft = true;
    var versuche = 0;
    var timer = setInterval(function() {
      versuche++;
      if (_queueAbarbeiten() || versuche > 20) {   // max. ~10 s
        clearInterval(timer);
        _queueLaeuft = false;
      }
    }, 500);
  };

  // ═══ BOOT ═══

  function initPB4() {
    var c = document.getElementById('projektberater-v4-app');
    if (c) new PB4(c);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPB4);
  else initPB4();

  // Theme-Editor: Nach jeder Setting-Aenderung ersetzt Shopify das Section-Markup;
  // das per innerHTML eingefuegte Skript laeuft dabei nicht erneut. Ohne diesen
  // Listener waere das Tool im Editor nach der ersten Aenderung tot.
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#projektberater-v4-app')) initPB4();
  });

})();
